//import axios from 'axios'
import { PrivateApiCall, PublicApiCall } from "./interceptors";
import Compressor from 'compressorjs';

const errorCatch = (error) => {
  console.log("ERROR API CALL", error, error?.response);
  if (error.response) {
    if (error.reponse?.data) {
      return error.response?.data;
    }
    return error.response;
  } else {
    return error;
  }
};

/** ******************************************************************************************* */
/** ************************************** AUTH *********************************************** */
/** ******************************************************************************************* */
async function login(data) {
  return await PublicApiCall.post("/auth/loginAdmin", data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function forgotPass(uuid, data) {
  return await PrivateApiCall.post(`/admin/users/${uuid}/resetPassword`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function otp(data) {
  return await PrivateApiCall.post(`/auth/otp`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function verifyOTP(data) {
  return await PrivateApiCall.post(`/auth/verifyAdmin`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

/** ******************************************************************************************* */
/** ************************************** ME-PROFILE ***************************************** */
/** ******************************************************************************************* */
async function getMeProfile() {
  return await PrivateApiCall.get("/admin/me")
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function editMeProfile(data) {
  return await PrivateApiCall.put(`/admin/me`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

/** ******************************************************************************************* */
/** ************************************** ADMIN-PROFILES ************************************* */
/** ******************************************************************************************* */
async function getAdminProfiles() {
  return await PrivateApiCall.get("/admin/admin-profiles")
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function addAdminProfile(data) {
  return await PrivateApiCall.post("/admin/admin-profile", data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function editAdminProfile(data, uuid) {
  return await PrivateApiCall.put(`/admin/admin-profile/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function deleteAdminProfile(uuid) {
  return await PrivateApiCall.delete(`/admin/admin-profile/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

/** ******************************************************************************************* */
/** ************************************** RESTAURANT ***************************************** */
/** ******************************************************************************************* */
async function getRestaurants() {
  return await PrivateApiCall.get("/admin/restaurant")
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function addRestaurant(data) {
  return await PrivateApiCall.post("/admin/restaurant", data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function editRestaurant(data, uuid) {
  return await PrivateApiCall.put(`/admin/restaurant/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function deleteRestaurant(uuid) {
  return await PrivateApiCall.delete(`/admin/restaurant/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

/** ******************************************************************************************* */
/** ************************************** BRANCHES ******************************************* */
/** ******************************************************************************************* */
async function getBranches(ruuid) {
  return await PrivateApiCall.get(`/admin/branch/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function getAllBranches() {
  return await PrivateApiCall.get(`/admin/branch`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function getBranchesOrders(ruuid) {
  return await PrivateApiCall.get(`/admin/branch/orders${ruuid ? `/${ruuid}` : ""}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function addBranch(ruuid, data) {
  return await PrivateApiCall.post(`/admin/branch/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function editBranch(ruuid, uuid, data) {
  return await PrivateApiCall.put(`/admin/branch/${ruuid}/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function deleteBranch(ruuid, uuid) {
  return await PrivateApiCall.delete(`/admin/branch/${ruuid}/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function getBranchesTableOrdering(ruuid) {
  return await PrivateApiCall.get(`/admin/branch/tableOrdering/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function getBranchesLoyalty(ruuid) {
  return await PrivateApiCall.get(`/admin/branch/loyalty/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function getBranchesQRMenu(ruuid) {
  return await PrivateApiCall.get(`/admin/branch/qrMenu/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function getBranchesFloorSetup(ruuid) {
  return await PrivateApiCall.get(`/admin/branch/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}


async function getBranchesOnlineDelivery(ruuid) {
  return await PrivateApiCall.get(`/admin/branch/onlineDelivery/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

/** ******************************************************************************************* */
/** ************************************** ENTITIES ******************************************* */
/** ******************************************************************************************* */
async function getEntities() {
  return await PrivateApiCall.get('/admin/branch/group')
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function addEntity(data) {
  return await PrivateApiCall.post('/admin/branch/group', data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function editEntity(uuid, data) {
  return await PrivateApiCall.put(`/admin/branch/group/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function bulkUpdateEntities(data) {
  return await PrivateApiCall.put('admin/branch/group-bulk', data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function deleteEntity(uuid) {
  return await PrivateApiCall.delete(`/admin/branch/group/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

/** ***************************************************************************************** */
/** ************************************* CATEGORY ***************************************** */
/** **************************************************************************************** */
//RI NEED CORRECTION
async function getCategories(ruuid) {
  return await PrivateApiCall.get(`/admin/productCategory/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function addCategory(ruuid, data) {
  return await PrivateApiCall.post(`/admin/productCategory/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function editCategory(ruuid, uuid, data) {
  return await PrivateApiCall.put(
    `/admin/productCategory/${ruuid}/${uuid}`,
    data
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function deleteCategory(ruuid, uuid) {
  return await PrivateApiCall.delete(`/admin/productCategory/${ruuid}/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function bulkUpdateCategories(ruuid, data) {
  return await PrivateApiCall.put(`/admin/productCategory/${ruuid}/`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function importCategories(ruuid, data) {
  return await PrivateApiCall.post(`/admin/productCategory/import/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function updateCategoryImages(ruuid, data) {
  return await PrivateApiCall.put(`/admin/productCategory/images/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function bulkAddCategories(ruuid, data) {
  return await PrivateApiCall.post(`/admin/productCategory/bulk/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ***************************************************************************************** */
/** ************************************* GROUP  ******************************************** */
/** ***************************************************************************************** */
//RI NEED CORRECTION
async function getGroups(ruuid) {
  return await PrivateApiCall.get(`/admin/productGroup/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function updateGroups(ruuid, data) {
  return await PrivateApiCall.put(`/admin/productGroup/images/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function addGroup(ruuid, data) {
  return await PrivateApiCall.post(`/admin/productGroup/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function editGroup(ruuid, uuid, data) {
  return await PrivateApiCall.put(`/admin/productGroup/${ruuid}/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function deleteGroup(ruuid, uuid) {
  return await PrivateApiCall.delete(`/admin/productGroup/${ruuid}/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function bulkEditGroups(ruuid, data) {
  return await PrivateApiCall.put(`/admin/productGroup/${ruuid}/`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function bulkAddGroups(ruuid, data) {
  return await PrivateApiCall.post(`/admin/productGroup/bulk/${ruuid}/`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function exportGroupsExcel(ruuid) {
  return await PrivateApiCall.get(`/admin/productGroup/export/template/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function importGroupsExcel(ruuid, data) {
  const formData = new FormData();
  formData.append('file', data);
  return await PrivateApiCall.post(`/admin/productGroup/import/${ruuid}`, formData)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** ************************************** TAXES ********************************************** */
/** ******************************************************************************************* */
async function getTaxes() {
  return await PrivateApiCall.get(`/admin/tax`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function addTax(data) {
  return await PrivateApiCall.post(`/admin/tax`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function editTax(uuid, data) {
  return await PrivateApiCall.put(`/admin/tax/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function deleteTax(uuid) {
  return await PrivateApiCall.delete(`/admin/tax/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function getBranchTaxes(ruuid) {
  return await PrivateApiCall.get(`/admin/branch-taxing/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function updateBranchTaxes(ruuid, data) {
  return await PrivateApiCall.put(`/admin/branch-taxing/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function applyTaxesToProducts(ruuid, data) {
  return await PrivateApiCall.put(`/admin/product/${ruuid}/apply-taxes`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function getProductsWithTaxes(ruuid) {
  return await PrivateApiCall.get(`/admin/product/${ruuid}/taxes`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function applyTaxesToAllProducts(ruuid, data) {
  return await PrivateApiCall.put(
    `/admin/product/${ruuid}/apply-taxes-to-all`,
    data
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function getModifiersWithTaxes(ruuid) {
  return await PrivateApiCall.get(`/admin/modifier/${ruuid}/taxes`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function applyTaxesToModifiers(ruuid, data) {
  return await PrivateApiCall.put(`/admin/modifier/${ruuid}/apply-taxes`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
/** ******************************************************************************************* */
/** ************************************** Ingredients ********************************************** */
/** ******************************************************************************************* */
async function getIngredients() {
  return await PrivateApiCall.get(`/admin/ingredient`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function addIngredient(data) {
  return await PrivateApiCall.post(`/admin/ingredient`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function editIngredient(uuid, data) {
  return await PrivateApiCall.put(`/admin/ingredient/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function deleteIngredient(uuid) {
  return await PrivateApiCall.delete(`/admin/ingredient/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function bulkUpdateIngredients(data) {
  return await PrivateApiCall.put(`/admin/ingredient/`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function updateIngredientImages(data) {
  return await PrivateApiCall.put(`/admin/ingredient/images`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function bulkAddIngredients(data) {
  return await PrivateApiCall.post(`/admin/ingredient/bulk`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function exportIngredientsExcel() {
  return await PrivateApiCall.get(`/admin/ingredient/export/template`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function importIngredientsExcel(data) {
  const formData = new FormData();
  formData.append('file', data);
  return await PrivateApiCall.post(`/admin/ingredient/import`, formData)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** ************************************TYPES AND ALLERGIES *********************************** */
/** ******************************************************************************************* */
async function getTypesAndAllergies(ruuid) {
  return await PrivateApiCall.get(`/admin/foodTypesAndAlergies/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function getSingleTypeAndAllergies(ruuid, uuid) {
  return await PrivateApiCall.get(`/admin/foodTypesAndAlergies/${ruuid}/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function addTypesAndAllergies(ruuid, data) {
  return await PrivateApiCall.post(`/admin/foodTypesAndAlergies/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function editTypesAndAllergies(ruuid, uuid, data) {
  return await PrivateApiCall.put(
    `/admin/foodTypesAndAlergies/${ruuid}/${uuid}`,
    data
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function deleteTypesAndAllergies(ruuid, uuid) {
  return await PrivateApiCall.delete(
    `/admin/foodTypesAndAlergies/${ruuid}/${uuid}`
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function updateTypesAndAllergies(ruuid, data) {
  return await PrivateApiCall.put(`/admin/foodTypesAndAlergies/images/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function bulkUpdateTypes(ruuid, data) {
  return await PrivateApiCall.put(`/admin/foodTypesAndAlergies/${ruuid}/`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function bulkAddTypes(ruuid, data) {
  return await PrivateApiCall.post(`/admin/foodTypesAndAlergies/bulk/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function exportFoodTypesExcel(ruuid) {
  return await PrivateApiCall.get(`/admin/foodTypesAndAlergies/export/template/${ruuid}/`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function importFoodTypesExcel(ruuid, data) {
  const formData = new FormData();
  formData.append('file', data);
  return await PrivateApiCall.post(`/admin/foodTypesAndAlergies/import/${ruuid}/`, formData)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** ************************************** PRODUCTS ******************************************* */
/** ******************************************************************************************* */
async function getProducts(ruuid) {
  return await PrivateApiCall.get(`/admin/product/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function getProduct(ruuid, uuid) {
  return await PrivateApiCall.get(`/admin/product/${ruuid}/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function addProduct(ruuid, data) {
  return await PrivateApiCall.post(`/admin/product/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function editProduct(data, ruuid, uuid) {
  return await PrivateApiCall.put(`/admin/product/${ruuid}/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function updateProducts(ruuid, data) {
  return await PrivateApiCall.put(`/admin/product/images/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function deleteProduct(ruuid, uuid) {
  return await PrivateApiCall.delete(`/admin/product/${ruuid}/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function deleteProductImage(ruuid, uuid) {
  return await PrivateApiCall.put(
    `/admin/product/${ruuid}/${uuid}/delete-image`
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function editProductImage(ruuid, uuid, data) {
  return await PrivateApiCall.post(
    `/admin/upload/${ruuid}/product-image/${uuid}`,
    data
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function editBulkProducts(ruuid, data) {
  return await PrivateApiCall.put(`/admin/product/${ruuid}/bulk-update`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function addBulkProducts(ruuid, data) {
  return await PrivateApiCall.post(`/admin/product/${ruuid}/bulk-add`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function getRewardsProducts(ruuid) {
  return await PrivateApiCall.get(`/admin/product/rewards/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getAddEditProducts(ruuid) {
  return await PrivateApiCall.get(`/admin/product/product-add-edit/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function generateImage(data) {
  return await PrivateApiCall.post(`/admin/product/generate-image`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}
async function uploadProductMediaGallery(ruuid, data) {
  const formData = new FormData();
  formData.append('media', data);
  return await PrivateApiCall.post(`/admin/upload/${ruuid}/product-media-gallery`, formData)
    .then(response => response)
    .catch(error => errorCatch(error));
}

async function importProducts(ruuid, data) {
  const formData = new FormData();
  formData.append('file', data);
  return await PrivateApiCall.post(`/admin/product/import/${ruuid}`, formData)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getProductExelTemplate(ruuid) {
  return await PrivateApiCall.get(`/admin/product/export/template/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** ************************************** MODIFIERS ********************************************** */
/** ******************************************************************************************* */
async function getModifiers(ruuid) {
  return await PrivateApiCall.get(`/admin/modifier/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function getModifier(ruuid, uuid) {
  return await PrivateApiCall.get(`/admin/modifier/${ruuid}/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function addModifier(ruuid, data) {
  return await PrivateApiCall.post(`/admin/modifier/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function editModifier(ruuid, uuid, data) {
  return await PrivateApiCall.put(`/admin/modifier/${ruuid}/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function deleteModifier(ruuid, uuid) {
  return await PrivateApiCall.delete(`/admin/modifier/${ruuid}/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function updateModifiers(ruuid, data) {
  return await PrivateApiCall.put(`/admin/modifier/images/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function bulkUpdateModifiers(ruuid, data) {
  return await PrivateApiCall.put(`/admin/modifier/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function bulkAddModifiers(ruuid, data) {
  return await PrivateApiCall.post(`/admin/modifier/bulk/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function exportModifiersExcel(ruuid) {
  return await PrivateApiCall.get(`/admin/modifier/export/template/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function importModifiersExcel(ruuid, data) {
  const formData = new FormData();
  formData.append('file', data);
  return await PrivateApiCall.post(`/admin/modifier/import/${ruuid}`, formData)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** ************************************** MODIFIERSGROUPS ********************************************** */
/** ******************************************************************************************* */
async function getModifiersGroups(ruuid) {
  return await PrivateApiCall.get(`/admin/modifierGroups/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function getModifierGroup(ruuid, uuid) {
  return await PrivateApiCall.get(`/admin/modifierGroups/${ruuid}/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function getModifierGroupWithModifiers(ruuid, uuid) {
  return await PrivateApiCall.get(
    `/admin/modifierGroups/${ruuid}/${uuid}/modifiers`
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function getModifiersGroupsWithModifiers(ruuid) {
  return await PrivateApiCall.get(`/admin/modifierGroups/${ruuid}/modifiers`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function addModifierGroup(ruuid, data) {
  return await PrivateApiCall.post(`/admin/modifierGroups/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function editModifierGroup(ruuid, uuid, data) {
  return await PrivateApiCall.put(
    `/admin/modifierGroups/${ruuid}/${uuid}`,
    data
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function deleteModifierGroup(ruuid, uuid) {
  return await PrivateApiCall.delete(`/admin/modifierGroups/${ruuid}/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function bulkUpdateModifierGroups(ruuid, data) {
  return await PrivateApiCall.put(`/admin/modifierGroups/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function bulkAddModifierGroups(ruuid, data) {
  return await PrivateApiCall.post(`/admin/modifierGroups/bulk/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function exportModGroupsExcel(ruuid) {
  return await PrivateApiCall.get(`/admin/modifierGroups/export/template/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function importModGroupsExcel(ruuid, data) {
  const formData = new FormData();
  formData.append('file', data);
  return await PrivateApiCall.post(`/admin/modifierGroups/import/${ruuid}`, formData)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}
/** ******************************************************************************************* */
/** ************************************** Roles ********************************************** */
/** ******************************************************************************************* */
async function getRoles() {
  return await PrivateApiCall.get(`/admin/role`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function addRole(data) {
  return await PrivateApiCall.post(`/admin/role`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function editRole(uuid, data) {
  return await PrivateApiCall.put(`/admin/role/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function deleteRole(uuid) {
  return await PrivateApiCall.delete(`/admin/role/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
/** ******************************************************************************************* */
/** ************************************** Users ********************************************** */
/** ******************************************************************************************* */
async function getUsers() {
  return await PrivateApiCall.get(`/admin/users/adminUsers`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function addUser(data) {
  return await PrivateApiCall.post(`/admin/users/adminUsers`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function editUser(uuid, data) {
  return await PrivateApiCall.put(`/admin/users/edit/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function deleteUser(uuid) {
  return await PrivateApiCall.delete(`/admin/users/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function editUserSettings(data) {
  return await PrivateApiCall.put(`/admin/users/settings`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function changeAccountActivity(uuid, data) {
  return await PrivateApiCall.post(`/admin/users/${uuid}/status`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}
async function changeAccountVerification(uuid, data) {
  return await PrivateApiCall.post(`/admin/users/${uuid}/verification`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}
async function getAppUsers() {
  return await PrivateApiCall.get(`/admin/app-users/`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function getAppUser(uuid) {
  return await PrivateApiCall.get(`/admin/app-users/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function addAppUser(data) {
  return await PrivateApiCall.post(`/admin/app-users/add`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function editAppUser(uuid, data) {
  return await PrivateApiCall.put(`/admin/app-users/${uuid}/edit`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function bulkEditAppUsers(data) {
  return await PrivateApiCall.put(`/admin/app-users/bulk-edit`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function bulkAddAppUsers(data) {
  return await PrivateApiCall.post(`/admin/app-users/bulk-add`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function deleteAppUser(uuid) {
  return await PrivateApiCall.put(`/admin/app-users/${uuid}/delete`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function getRestaurantsWithBranches() {
  return await PrivateApiCall.get(`/admin/restaurant/branches`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function exportAppUsersExcel() {
  return await PrivateApiCall.get(`/admin/app-users/export/template`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function importAppUsersExcel(data) {
  const formData = new FormData();
  formData.append('file', data);
  return await PrivateApiCall.post(`/admin/app-users/import`, formData)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** ************************************** POS Users ********************************************** */
/** ******************************************************************************************* */
async function getPosUsers() {
  return await PrivateApiCall.get(`/admin/pos-user`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function getPosUser(uuid, data) {
  return await PrivateApiCall.get(`/admin/pos-user//${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function addPosUser(data) {
  return await PrivateApiCall.post(`/admin/pos-user`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function editPosUser(uuid, data) {
  return await PrivateApiCall.put(`/admin/pos-user/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function deletePosUser(uuid) {
  return await PrivateApiCall.delete(`/admin/pos-user/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function getPosBranches(puuid) {
  return await PrivateApiCall.get(`/admin/pos-user/branches/${puuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function getAllPosBranches() {
  return await PrivateApiCall.get(`/admin/branch/pos`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

/** ******************************************************************************************* */
/** ********************************** APP USERS ADDRESSES ************************************ */
/** ******************************************************************************************* */

async function getAppUserAddresses(uuid) {
  return await PrivateApiCall.get(`/admin/app-users-address/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function addAppUserAddress(uuid, data) {
  return await PrivateApiCall.post(`/admin/app-users-address/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function editAppUserAddress(uuid, data) {
  return await PrivateApiCall.put(`/admin/app-users-address/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function deleteAppUserAddress(uuid) {
  return await PrivateApiCall.delete(`/admin/app-users-address/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

/** ******************************************************************************************* */
/** *********************************** APP USERS GROUPS ************************************** */
/** ******************************************************************************************* */
async function getAppUsersGroups() {
  return await PrivateApiCall.get(`/admin/app-users-group`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function addAppUsersGroup(data) {
  return await PrivateApiCall.post(`/admin/app-users-group/`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}
async function editAppUsersGroup(uuid, data) {
  return await PrivateApiCall.put(`/admin/app-users-group/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}
async function deleteAppUsersGroup(uuid) {
  return await PrivateApiCall.delete(`/admin/app-users-group/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** *************************************** ALLERGENS ***************************************** */
/** ******************************************************************************************* */
async function getAllergens() {
  return await PrivateApiCall.get(`/admin/allergen`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function getAllergen(uuid) {
  return await PrivateApiCall.get(`/admin/allergen/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function addAllergen(data) {
  return await PrivateApiCall.post(`/admin/allergen`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function editAllergen(uuid, data) {
  return await PrivateApiCall.put(`/admin/allergen/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function deleteAllergen(uuid) {
  return await PrivateApiCall.delete(`/admin/allergen/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function bulkUpdateAllergens(data) {
  return await PrivateApiCall.put(`/admin/allergen/`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function bulkAddAllergens(data) {
  return await PrivateApiCall.post(`/admin/allergen/bulk`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function updateAllergensImages(data) {
  return await PrivateApiCall.put(`/admin/allergen/images/upload`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** ******************************************* MENU ****************************************** */
/** ******************************************************************************************* */
async function getMenu(ruuid, uuid) {
  return await PrivateApiCall.get(`/admin/menu/${ruuid}/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function getMenus(ruuid) {
  return await PrivateApiCall.get(`/admin/menu/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function addMenu(ruuid, data) {
  return await PrivateApiCall.post(`/admin/menu/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function editMenu(ruuid, uuid, data) {
  return await PrivateApiCall.put(`/admin/menu/${ruuid}/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function deleteMenu(ruuid, uuid) {
  return await PrivateApiCall.delete(`/admin/menu/${ruuid}/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function editMenuName(ruuid, uuid, data) {
  return await PrivateApiCall.put(
    `/admin/menu/${ruuid}/${uuid}/update-name`,
    data
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function updateMenuSorting(ruuid, data) {
  return await PrivateApiCall.put(`/admin/menu/${ruuid}/update-order`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
/** ******************************************************************************************* */
/** ************************************** GLOBAL CONFIG ************************************** */
/** ******************************************************************************************* */

async function getGlobalConfig() {
  return await PublicApiCall.get("/globalconfig")
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function uploadImage(data, doNotCompress) {
  if (!doNotCompress)
    return new Promise((resolve, reject) => {
      new Compressor(data, {
        quality: 0.2,
        success(result) {
          // const compressedFile = Object.assign(result, {
          //   path: data.name,
          //   preview: URL.createObjectURL(result)
          // });
          const formData = new FormData();
          formData.append('image', result);
          // Now upload the compressed file
          PrivateApiCall.post("/admin/upload/image", formData)
            .then(response => resolve(response))
            .catch(error => reject(error));
        },
        error(err) {
          console.error(err.message);
          reject(err);
        },
      });
    });
  else {
    const formData = new FormData();
    formData.append('image', data);
    return await PrivateApiCall.post("/admin/upload/image", formData)
      .then(response => response)
      .catch(error => errorCatch(error));
  }
}

async function bulkUploadImages(images, doNotCompress = false) {
  if (!Array.isArray(images) || images.length === 0 || images.length > 50) {
    throw new Error('Please provide an array of 1-50 images');
  }

  const processedImages = await Promise.all(
    images.map(image => {
      if (doNotCompress) {
        return Promise.resolve(image);
      }

      return new Promise((resolve, reject) => {
        new Compressor(image, {
          quality: 0.2,
          success(result) {
            const fileName = image.name || 'compressed-image.jpg';
            const file = new File([result], fileName, {
              type: result.type,
              lastModified: Date.now()
            });
            resolve(file);
          },
          error(err) {
            console.error('Compression error:', err.message);
            reject(err);
          },
        });
      });
    })
  );

  const formData = new FormData();
  await processedImages.forEach(image => {
    formData.append(`image`, image);
  });

  try {
    const response = await PrivateApiCall.post("/admin/upload/image/bulk", formData);
    return response;
  } catch (error) {
    return errorCatch(error);
  }
}


async function uploadQr(data) {
  return await PrivateApiCall.post("/admin/upload/qr", data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** ************************************* TRANSLATIONS **************************************** */
/** ******************************************************************************************* */
async function getTranslations() {
  return await PublicApiCall.get("/language?platform=resto-admin")
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function getTranslationPages() {
  return await PrivateApiCall.get("/admin/translations/pages")
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function getMissingTranslations(pageName, ruuid, limit, page) {
  let url = `/admin/translations`
  if (pageName)
    url += `/${pageName}`
  if (ruuid)
    url += `/${ruuid}`
  url += `?limit=${limit}&page=${page}`
  return await PrivateApiCall.get(url)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}
async function editTranslations(data) {
  return await PrivateApiCall.put(`/admin/translations/`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}
async function aiTranslate(data) {
  return await PrivateApiCall.put(`/admin/translations/generate-translation`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}
async function aiGenerateDescription(data) {
  return await PrivateApiCall.put(`/admin/product/generate-productdescription`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}
async function getSupportedLanguagesSettings() {
  return await PrivateApiCall.get(`/admin/supported-languages/`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}
async function editSupportedLanguagesSettings(data) {
  return await PrivateApiCall.put(`/admin/supported-languages/`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}
async function getSupportedLanguages() {
  return await PrivateApiCall.get(`/language/admin`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}
/** ******************************************************************************************* */
/** ************************************** DELIVERY ZONE ************************************** */
/** ******************************************************************************************* */
async function getDeliveryZones(ruuid, bruuid, query) {
  return await PrivateApiCall.get(`/admin/delivery-zone${ruuid ? `/${ruuid}` : ""}${bruuid ? `/${bruuid}` : ""}${query ? `${query}` : ""}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function getDeliveryZone(ruuid, bruuid, uuid) {
  return await PrivateApiCall.get(
    `/admin/delivery-zone/${ruuid}/${bruuid}/${uuid}`
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function addDeliveryZone(ruuid, bruuid, data) {
  return await PrivateApiCall.post(
    `/admin/delivery-zone/${ruuid}/${bruuid}`,
    data
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function editDeliveryZone(ruuid, bruuid, uuid, data) {
  return await PrivateApiCall.put(
    `/admin/delivery-zone/${ruuid}/${bruuid}/${uuid}`,
    data
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function deleteDeliveryZone(ruuid, bruuid, uuid) {
  return await PrivateApiCall.delete(
    `/admin/delivery-zone/${ruuid}/${bruuid}/${uuid}`
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function getOnlineDeliverySettings(ruuid, bruuid) {
  return await PrivateApiCall.get(
    `/admin/online-delivery-setting/${ruuid}/${bruuid}`
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function getAllOnlineDeliverySettings(query) {
  return await PrivateApiCall.get(
    `/admin/online-delivery-setting/` + `${query ? `${query}` : ''}`
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function addEditDeliverySettings(ruuid, bruuid, data) {
  return await PrivateApiCall.post(
    `/admin/online-delivery-setting/${ruuid}/${bruuid}`,
    data
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
/** ******************************************************************************************* */
/** ***************************************** EVENTS ***************************************** */
/** ******************************************************************************************* */
async function getEvents(ruuid, bruuid) {
  return await PrivateApiCall.get(`/admin/events/${ruuid}/${bruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function getEvent(ruuid, bruuid, uuid) {
  return await PrivateApiCall.get(`/admin/events/${ruuid}/${bruuid}/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function addEvent(ruuid, bruuid, data) {
  return await PrivateApiCall.post(`/admin/events/${ruuid}/${bruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function editEvent(ruuid, bruuid, uuid, data) {
  return await PrivateApiCall.put(
    `/admin/events/${ruuid}/${bruuid}/${uuid}`,
    data
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function deleteEvent(ruuid, bruuid, uuid) {
  return await PrivateApiCall.delete(`/admin/events/${ruuid}/${bruuid}/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
/** ******************************************************************************************* */
/** ****************************************** MEDIA ****************************************** */
/** ******************************************************************************************* */
async function getAllMedia(ruuid, page, limit) {
  return await PrivateApiCall.get(
    page && limit
      ? `/admin/media/${ruuid}?page=${page}&limit=${limit}`
      : `/admin/media/${ruuid}`
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function getAllMediaInteractions(ruuid, uuid) {
  return await PrivateApiCall.get(`/admin/media/${ruuid}/${uuid}/get-all`);
}
async function addMedia(ruuid, data) {
  return await PrivateApiCall.post(`/admin/media/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function editMedia(ruuid, uuid, data) {
  return await PrivateApiCall.put(`/admin/media/${ruuid}/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function deleteMedia(ruuid, uuid) {
  return await PrivateApiCall.put(`/admin/media/${ruuid}/${uuid}/delete-media`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function hideMedia(ruuid, uuid) {
  return await PrivateApiCall.put(`/admin/media/${ruuid}/${uuid}/hide-media`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function showMedia(ruuid, uuid) {
  return await PrivateApiCall.put(`/admin/media/${ruuid}/${uuid}/show-media`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function sortMedia(ruuid, data) {
  return await PrivateApiCall.put(`/admin/media/${ruuid}/sort`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function updateMedia(ruuid, uuid, data) {
  return await PrivateApiCall.post(`/admin/upload/${ruuid}/media/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
/** ******************************************************************************************* */
/** **************************************** GALLERY ****************************************** */
/** ******************************************************************************************* */
async function getGallery(ruuid) {
  return await PrivateApiCall.get(`/admin/gallery/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function uploadGallery(ruuid, catuuid, data) {
  return await PrivateApiCall.post(
    `/admin/gallery/${ruuid}/${catuuid}/upload`,
    data
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function updateLayout(ruuid, data) {
  return await PrivateApiCall.put(`/admin/gallery/${ruuid}/`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function deleteGallery(ruuid, data) {
  return await PrivateApiCall.post(
    `/admin/gallery/${ruuid}/delete-photos`,
    data
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function getGalleryCategories(ruuid) {
  return await PrivateApiCall.get(`/admin/gallery/${ruuid}/gallery-categories`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function getGalleryCategory(ruuid, catuuid) {
  return await PrivateApiCall.get(
    `/admin/gallery/${ruuid}/${catuuid}/gallery-categories`
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function addGalleryCategory(ruuid, data) {
  return await PrivateApiCall.post(
    `/admin/gallery/${ruuid}/gallery-categories`,
    data
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function editGalleryCategory(ruuid, catuuid, data) {
  return await PrivateApiCall.put(
    `/admin/gallery/${ruuid}/${catuuid}/gallery-categories`,
    data
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function deleteGalleryCategory(ruuid, catuuid) {
  return await PrivateApiCall.delete(
    `/admin/gallery/${ruuid}/${catuuid}/gallery-categories`
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
/** ******************************************************************************************* */
/** **************************************** FEEDBACK ***************************************** */
/** ******************************************************************************************* */
async function getFeedbackTemplate(ruuid) {
  return await PrivateApiCall.get(`/admin/feedback-template/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function editFeedbackTemplate(ruuid, data) {
  return await PrivateApiCall.put(`/admin/feedback-template/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function editFeedbackTemplateMessage(ruuid, data) {
  return await PrivateApiCall.put(
    `/admin/feedback-templateMessage/${ruuid}`,
    data
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function getFeedback(ruuid) {
  return await PrivateApiCall.get(`/admin/feedback/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function addFeedback(ruuid, data) {
  return await PrivateApiCall.post(`/admin/feedback/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function editFeedbackComplaint(ruuid, fuuid, data) {
  return await PrivateApiCall.put(`/admin/feedback/${ruuid}/${fuuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

/** ******************************************************************************************* */
/** **************************************** MODULES ***************************************** */
/** ******************************************************************************************* */
async function getModules() {
  return await PrivateApiCall.get(`/organisation/modules`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
/** ******************************************************************************************* */
/** **************************************** PLATFORMS ***************************************** */
/** ******************************************************************************************* */
async function getPlatforms(ruuid) {
  return await PrivateApiCall.get(`/admin/platform/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function addPlatform(ruuid, data) {
  return await PrivateApiCall.post(`/admin/platform/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function editPlatform(ruuid, uuid, data) {
  return await PrivateApiCall.put(`/admin/platform/${ruuid}/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function deletePlatform(ruuid, uuid) {
  return await PrivateApiCall.delete(`/admin/platform/${ruuid}/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
/** ****************************************************************************************** */
/** ************************************** PROMOTIONS **************************************** */
/** ****************************************************************************************** */
async function getAllPromotions(ruuid) {
  return await PrivateApiCall.get(`/admin/promotion/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function getPromotion(ruuid, uuid) {
  return await PrivateApiCall.get(`/admin/promotion/${ruuid}/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function addPromotion(ruuid, data) {
  return await PrivateApiCall.post(`/admin/promotion/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function editPromotion(ruuid, uuid, data) {
  return await PrivateApiCall.put(`/admin/promotion/${ruuid}/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function deletePromotion(ruuid, uuid) {
  return await PrivateApiCall.delete(`/admin/promotion/${ruuid}/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
/** ****************************************************************************************** */
/** ************************************** BRANCH-FINANCE **************************************** */
/** ****************************************************************************************** */
async function getBranchesFinance(ruuid) {
  return await PrivateApiCall.get(`/admin/product/${ruuid}/branch-finances`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function updateBranchesFinanceAvailability(ruuid, data) {
  return await PrivateApiCall.put(
    `/admin/product/${ruuid}/branch-finance-availability`,
    data
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function updateBranchesFinancePrice(ruuid, data) {
  return await PrivateApiCall.put(
    `/admin/product/${ruuid}/branch-finance-price`,
    data
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function getBranchesFinanceProduct(ruuid, uuid) {
  return await PrivateApiCall.get(`/admin/product/${ruuid}/${uuid}/branch-finances`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ****************************************************************************************** */
/** ************************************** LOYALTY ******************************************* */
/** ****************************************************************************************** */
async function getLoyalty(ruuid) {
  return await PrivateApiCall.get(`/admin/loyality/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function addEditLoyalty(ruuid, data) {
  return await PrivateApiCall.put(`/admin/loyality/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function addEditLoyaltyDescription(ruuid, data) {
  return await PrivateApiCall.put(`/admin/loyality/${ruuid}/description`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function getLoyaltyDescription(ruuid) {
  return await PrivateApiCall.get(`/admin/loyality/${ruuid}/description`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function getLoyaltyUsers(ruuid) {
  return await PrivateApiCall.get(`/admin/loyality-user/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function addLoyaltyConfig(ruuid, data) {
  return await PrivateApiCall.put(`/admin/general-config/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function getLoyaltyConfig(ruuid) {
  return await PrivateApiCall.get(`/admin/general-config/${ruuid ? ruuid : ''}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function getLoyaltyMenu(ruuid) {
  return await PrivateApiCall.get(`/admin/loyality-rewards/${ruuid}/menu`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function addEditLoyaltyMenu(ruuid, data) {
  return await PrivateApiCall.put(`/admin/loyality-rewards/${ruuid}/menu`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function getCashback(ruuid) {
  return await PrivateApiCall.get(`/admin/loyality-rewards/${ruuid}/CASHBACK`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function getGifts(ruuid) {
  return await PrivateApiCall.get(`/admin/loyality-rewards/${ruuid}/gifts`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function getGift(ruuid, uuid) {
  return await PrivateApiCall.get(
    `/admin/loyality-rewards/${ruuid}/${uuid}/gifts`
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function addEditCashback(ruuid, data) {
  return await PrivateApiCall.put(
    `/admin/loyality-rewards/${ruuid}/cashback`,
    data
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function editGift(ruuid, uuid, data) {
  return await PrivateApiCall.put(
    `/admin/loyality-rewards/${ruuid}/${uuid}/gifts`,
    data
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function addGift(ruuid, data) {
  return await PrivateApiCall.post(
    `/admin/loyality-rewards/${ruuid}/gifts`,
    data
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function deleteGift(ruuid, uuid) {
  return await PrivateApiCall.delete(
    `/admin/loyality-rewards/${ruuid}/${uuid}/gifts`
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function getRewardsBasedOnLevel(ruuid) {
  return await PrivateApiCall.get(
    `/admin/loyality-rewards/${ruuid}/reward-based-onlevel`
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function getRewardBasedOnLevel(ruuid, uuid) {
  return await PrivateApiCall.get(
    `/admin/loyality-rewards/${ruuid}/${uuid}/reward-based-onlevel`
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function deleteRewardBasedOnLevel(ruuid, uuid) {
  return await PrivateApiCall.delete(
    `/admin/loyality-rewards/${ruuid}/${uuid}/reward-based-onlevel`
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function editRewardBasedOnLevel(ruuid, uuid, data) {
  return await PrivateApiCall.put(
    `/admin/loyality-rewards/${ruuid}/${uuid}/reward-based-onlevel`,
    data
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function addRewardBasedOnLevel(ruuid, data) {
  return await PrivateApiCall.post(
    `/admin/loyality-rewards/${ruuid}/reward-based-onlevel`,
    data
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function editLoyaltyPoints(ruuid, uuid, data) {
  return await PrivateApiCall.put(`/admin/loyality-user/${ruuid}/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function getLoyaltyUserEntries(ruuid, uuid) {
  return await PrivateApiCall.get(ruuid ? `/admin/loyality-user/entries/${ruuid}/${uuid}` : `/admin/loyality-user/entries/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch((error)))
}
/** ****************************************************************************************** */
/** ************************************** DISCOUNT ******************************************* */
/** ****************************************************************************************** */
async function getAllDiscount(ruuid) {
  return await PrivateApiCall.get(`/admin/discount/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function getDiscount(ruuid, uuid) {
  return await PrivateApiCall.get(`/admin/discount/${ruuid}/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function addDiscount(ruuid, data) {
  return await PrivateApiCall.post(`/admin/discount/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function editDiscount(ruuid, uuid, data) {
  return await PrivateApiCall.put(`/admin/discount/${ruuid}/${uuid}/edit`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function deleteDiscount(ruuid, uuid) {
  return await PrivateApiCall.delete(`/admin/discount/${ruuid}/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function sortDiscount(ruuid, data) {
  return await PrivateApiCall.put(`/admin/discount/${ruuid}/sort`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}
async function editDiscountSettings(ruuid, data) {
  return await PrivateApiCall.put(`/admin/discount/${ruuid}/settings`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getDiscountSettings(ruuid) {
  return await PrivateApiCall.get(`/admin/discount/${ruuid}/settings`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** ***************************************** ORDERS ****************************************** */
/** ******************************************************************************************* */

async function getOrders(ruuid, buuid, page, limit, filterUrl, cancelToken) {
  return await PrivateApiCall.get(`/admin/order/paginated` + (ruuid ? `/${ruuid}` : '') + (buuid ? `/${buuid}` : '') + `?page=${page}&limit=${limit}${filterUrl ? `&${filterUrl}` : ""}`, {
    cancelToken: cancelToken,
  })
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function checkIfOrderMeetsFilters(ruuid, buuid, ouuid, filterUrl) {
  return await PrivateApiCall.get(`/admin/order/check-if-in-filters/${ruuid}/${buuid}/${ouuid}${filterUrl ? `?${filterUrl}` : ""}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

//   return await PrivateApiCall.get(`/admin/order/paginated/${ruuid}/${buuid}?page=${page}&limit=${limit}${filter}`)
//     .then((response) => response)
//     .catch((error) => errorCatch(error));
// }

async function getOrder(ruuid, buuid, ouuid) {
  return await PrivateApiCall.get(`/admin/order/${ruuid}/${buuid}/${ouuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function cancelOrder(ruuid, buuid, ouuid, wasOrderAccepted = false, data) {
  return await PrivateApiCall.put(
    `/admin/order/${ruuid}/${buuid}/${ouuid}/${wasOrderAccepted ? "cancel-accepted-order" : "cancel-order"}`, data
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function acceptOrder(ruuid, buuid, ouuid) {
  return await PrivateApiCall.put(
    `/admin/order/${ruuid}/${buuid}/${ouuid}/accept-order`
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function rejectOrder(ruuid, buuid, ouuid, wasOrderAccepted = false, data) {
  return await PrivateApiCall.put(
    `/admin/order/${ruuid}/${buuid}/${ouuid}/${wasOrderAccepted ? "reject-accepted-order" : "reject-order"}`, data
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function completeOrder(ruuid, buuid, ouuid) {
  return await PrivateApiCall.put(
    `/admin/order/${ruuid}/${buuid}/${ouuid}/complete-order`
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function dispatchOrder(ruuid, bruuid, data) {
  return await PrivateApiCall.put(`/admin/order/${ruuid}/${bruuid}/dispatch-order`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function updateDispatchSettings(ruuid, data) {
  return await PrivateApiCall.put(`/admin/general-config/dispatch-setup/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getDrivers(ruuid, bruuid) {
  return await PrivateApiCall.get(`/admin/order/get-drivers${ruuid ? `/${ruuid}` : ""}${bruuid ? `/${bruuid}` : ""}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getDriver(uuid, query) {
  return await PrivateApiCall.get(`/admin/order/get-driver-details/${uuid}${query ? `?${query}` : ""}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function undispatchAllOrders(ruuid, bruuid, duuid, filterUrl) {
  return await PrivateApiCall.put(`/admin/order${ruuid ? `/${ruuid}` : ""}${bruuid ? `/${bruuid}` : ""}/undispatch-orders/${duuid}${filterUrl ? `${filterUrl}` : ""}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function undispatchOrder(ruuid, bruuid, duuid, ouuid) {
  return await PrivateApiCall.put(`/admin/order/${ruuid}/${bruuid}/undispatch-order/${duuid}/${ouuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function setBusy(ruuid, bruuid, data, query) {
  return await PrivateApiCall.put(`/admin/order/${ruuid}/${bruuid}/set-busy` + `${query ? query : ''}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function setBusyAll(data, query) {
  return await PrivateApiCall.put(`/admin/order/set-busy-all` + `${query ? query : ''}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getUnclosedDays(ruuid, bruuid, query) {
  return await PrivateApiCall.get(`/admin/report${ruuid ? `${ruuid}` : ''}${bruuid ? `${bruuid}` : ''}/unclosed-dates${query ? `${query}` : ''}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function closeDay(ruuid, bruuid, closingDay) {
  return await PrivateApiCall.post(`/admin/report/close-day/${ruuid}/${bruuid}`, closingDay)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function setClosed(ruuid, bruuid, data, query) {
  return await PrivateApiCall.put(`/admin/order/${ruuid}/${bruuid}/set-close` + `${query ? query : ''}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function setClosedAll(data, query) {
  return await PrivateApiCall.put(`/admin/order/set-close-all` + `${query ? query : ''}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getTodayReport(ruuid, bruuid, selectedDate, query) {
  return await PrivateApiCall.get(`/admin/report${ruuid ? `${ruuid}` : ''}${bruuid ? `${bruuid}` : ''}/reports?key=not-closed${query ? `${query}` : ''}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getClosedReport(ruuid, bruuid, selectedDate) {
  return await PrivateApiCall.get(`/admin/report/${ruuid}/${bruuid}/reports?selectedDate=${selectedDate}&key=closed`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getReportDates(ruuid, bruuid) {
  return await PrivateApiCall.get(`/admin/report/${ruuid}/${bruuid}/report-dates`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getReasons() {
  return await PrivateApiCall.get(`/admin/reasons`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function addReason(data) {
  return await PrivateApiCall.post(`/admin/reasons`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function editReason(uuid, data) {
  return await PrivateApiCall.put(`/admin/reasons/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function deleteReason(uuid) {
  return await PrivateApiCall.delete(`/admin/reasons/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** ************************************** ORDERS HISTORY ************************************* */
/** ******************************************************************************************* */
// async function getOrdersHistory(ruuid, buuid, page, limit, filterUrl) {
//   return await PrivateApiCall.get(`/admin/order/history/${ruuid}/${buuid}?page=${1}&limit=${limit}${filterUrl ? filterUrl : ""}`)
//     .then((response) => response)
//     .catch((error) => errorCatch(error));
// }

async function getOrdersHistory(ruuid, buuid, page, limit, filterUrl, cancelToken) {
  return await PrivateApiCall.get(`/admin/order/history` + (ruuid ? `/${ruuid}` : '') + (buuid ? `/${buuid}` : '') + `?page=${page}&limit=${limit}${filterUrl ? filterUrl : ""}`, {
    cancelToken: cancelToken,
  })
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
/** ******************************************************************************************* */
/** *****************************************  FLOOR SETUP  ****************************************** */
/** ******************************************************************************************* */

async function getFloors(ruuid, bruuid) {
  return await PrivateApiCall.get(`/admin/floor/${ruuid}/${bruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getFloor(ruuid, bruuid, fuuid) {
  return await PrivateApiCall.get(`/admin/floor/${ruuid}/${bruuid}/${fuuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getTables(fuuid) {
  return await PrivateApiCall.get(`/admin/table/${fuuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function editOrAddFloorsAndTables(ruuid, bruuid, data) {
  return await PrivateApiCall.put(`/admin/floor/${ruuid}/${bruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function deleteTheFloor(ruuid, bruuid, fuuid) {
  return await PrivateApiCall.delete(`/admin/floor/${ruuid}/${bruuid}/${fuuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function deleteTable(fuuid, tuuid) {
  return await PrivateApiCall.delete(`/admin/table/${fuuid}/${tuuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** *****************************************  QR  ****************************************** */
/** ******************************************************************************************* */

async function addQR(ruuid, bruuid, data) {
  return await PrivateApiCall.post(`/admin/qr/qr-setup/${ruuid}/${bruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function addQrTables(ruuid, bruuid, data) {
  return await PrivateApiCall.post(`/admin/qr/qr-tables/${ruuid}/${bruuid}/`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function addQrButton(ruuid, bruuid, data) {
  return await PrivateApiCall.post(`/admin/qr/qr-button/${ruuid}/${bruuid}/`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function editQrButton(ruuid, bruuid, uuid, data) {
  return await PrivateApiCall.put(`/admin/qr/qr-button/${ruuid}/${bruuid}/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function deleteQrButton(ruuid, bruuid, uuid) {
  return await PrivateApiCall.delete(`/admin/qr/qr-button/${ruuid}/${bruuid}/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function deleteQrTable(ruuid, bruuid, uuid) {
  return await PrivateApiCall.delete(`/admin/qr/qr-tables/${ruuid}/${bruuid}/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getQrButton(ruuid, bruuid, uuid) {
  return await PrivateApiCall.get(`/admin/qr/qr-button/${ruuid}/${bruuid}/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getQrButtons(ruuid, bruuid) {
  return await PrivateApiCall.get(`/admin/qr/qr-button/${ruuid}/${bruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getQr(ruuid, bruuid) {
  return await PrivateApiCall.get(`/admin/qr/qr-setup/${ruuid}/${bruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function validateURL(ruuid, bruuid, data) {
  return await PrivateApiCall.post(`/admin/qr/url-validation/${ruuid}/${bruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}
async function getQrTables(ruuid, bruuid) {
  return await PrivateApiCall.get(`/admin/qr/qr-tables/${ruuid}/${bruuid}/`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}
async function getTableOrderingSettings(ruuid, bruuid) {
  return await PrivateApiCall.get(`/admin/table-ordering-setting/${ruuid}/${bruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}
async function addEditTableOrderingSettings(ruuid, bruuid, data) {
  return await PrivateApiCall.post(`/admin/table-ordering-setting/${ruuid}/${bruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}
async function getQrOnlineDelivery(ruuid) {
  return await PrivateApiCall.get(`/admin/qr/online-ordering/${ruuid}/`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}
async function addOnlineDeliveryQr(ruuid, data) {
  return await PrivateApiCall.post(`/admin/qr/online-ordering/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}
async function getQROrderingSettings(ruuid) {
  return await PrivateApiCall.get(
    `/admin/general-config/get-order-config/${ruuid}`
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
async function setQROrderingSettings(ruuid, data) {
  return await PrivateApiCall.post(
    `/admin/general-config/set-order-config/${ruuid}`,
    data
  )
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

/** ******************************************************************************************* */
/** *************************************** ENTITY QR  **************************************** */
/** ******************************************************************************************* */
//entity qr
async function getEntityQr(euuid) {
  return await PrivateApiCall.get(`/admin/qr/entity-ordering/qr-setup/${euuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function addEditEntityQr(euuid, data) {
  return await PrivateApiCall.post(`/admin/qr/entity-ordering/qr-setup/${euuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

//entity qr tables
async function getEntityQrTables(euuid) {
  return await PrivateApiCall.get(`/admin/qr/entity-ordering/qr-tables/${euuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function addEntityQrTables(euuid, data) {
  return await PrivateApiCall.post(`/admin/qr/entity-ordering/qr-tables/${euuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function deleteEntityQrTable(euuid, uuid) {
  return await PrivateApiCall.delete(`/admin/qr/entity-ordering/qr-tables/${euuid}/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

//entity qr buttons
async function getEntityQrButton(euuid, uuid) {
  return await PrivateApiCall.get(`/admin/qr/entity-ordering/qr-button/${euuid}/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getEntityQrButtons(euuid) {
  return await PrivateApiCall.get(`/admin/qr/entity-ordering/qr-button/${euuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function addEntityQrButton(euuid, data) {
  return await PrivateApiCall.post(`/admin/qr/entity-ordering/qr-button/${euuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function editEntityQrButton(euuid, uuid, data) {
  return await PrivateApiCall.put(`/admin/qr/entity-ordering/qr-button/${euuid}/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function deleteEntityQrButton(euuid, uuid) {
  return await PrivateApiCall.delete(`/admin/qr/entity-ordering/qr-button/${euuid}/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}
/** ******************************************************************************************* */
/** *************************************  URL LINK  ****************************************** */
/** ******************************************************************************************* */
async function getAffiliateLink(ruuid) {
  return await PrivateApiCall.get(`/admin/affiliate-link/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function addAffiliateLink(ruuid, data) {
  return await PrivateApiCall.post(`/admin/affiliate-link/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function editAffiliateLink(ruuid, uuid, data) {
  return await PrivateApiCall.put(`/admin/affiliate-link/${ruuid}/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function deleteAffiliateLink(ruuid, uuid) {
  return await PrivateApiCall.delete(`/admin/affiliate-link/${ruuid}/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}
/** ******************************************************************************************* */
/** *************************************  DESIGN SETUP  ************************************** */
/** ******************************************************************************************* */

async function getDesignSetupGlobalSettings() {
  return await PrivateApiCall.get(`/admin/general-config/design-setup`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function editDesignSetupGlobalSettings(data) {
  return await PrivateApiCall.put(`/admin/general-config/design-setup`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getDesignSetup(ruuid) {
  return await PrivateApiCall.get(`/admin/design-setup/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function editDesignSetup(ruuid, data) {
  return await PrivateApiCall.post(`/admin/design-setup/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** **************************************  LOGIN SETUP  ************************************** */
/** ******************************************************************************************* */

async function getLoginDesignSetup() {
  return await PrivateApiCall.get(`/admin/loginDesignSetup`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function editLoginDesignSetup(data) {
  return await PrivateApiCall.put(`/admin/loginDesignSetup`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** **********************************  SPLASH SCREEN SETUP  ********************************** */
/** ******************************************************************************************* */

async function getSplashScreenDesignSetup() {
  return await PrivateApiCall.get(`/admin/splashScreen`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function editSplashScreenDesignSetup(data) {
  return await PrivateApiCall.put(`/admin/splashScreen`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** ********************************  RESTAURANTS DESIGN SETUP  ******************************* */
/** ******************************************************************************************* */

async function getRestaurantsDesignSetup() {
  return await PrivateApiCall.get(`/admin/restaurantsDesignSetup`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function editRestaurantsDesignSetup(data) {
  return await PrivateApiCall.put(`/admin/restaurantsDesignSetup`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** *********************************  PRODUCTS AVAILABILITY  ********************************* */
/** ******************************************************************************************* */

async function getProductsAvailability(ruuid, bruuid) {
  return await PrivateApiCall.get(`/admin/product-availability/${ruuid}/${bruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function deleteProductAvailability(ruuid, bruuid, pruuid) {
  return await PrivateApiCall.delete(`/admin/product-availability/${ruuid}/${bruuid}/${pruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function updateProductsAvailability(ruuid, bruuid, data) {
  return await PrivateApiCall.put(`/admin/product-availability/${ruuid}/${bruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** *********************************  AUTOMATED-MESSAGES  ********************************* */
/** ******************************************************************************************* */

async function getAutomatedMessages(ruuid) {
  return await PrivateApiCall.get(`/admin/automatedMessage/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getAutomatedMessage(ruuid, uuid) {
  return await PrivateApiCall.get(`/admin/automatedMessage/${ruuid}/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function addAutomatedMessage(ruuid, data) {
  return await PrivateApiCall.post(`/admin/automatedMessage/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function editAutomatedMessage(ruuid, uuid, data) {
  return await PrivateApiCall.put(`/admin/automatedMessage/${ruuid}/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function deleteAutomatedMessage(ruuid, uuid) {
  return await PrivateApiCall.delete(`/admin/automatedMessage/${ruuid}/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** *********************************  DIRECT-MESSAGES  ********************************* */
/** ******************************************************************************************* */

async function getDirectMessages(ruuid) {
  return await PrivateApiCall.get(`/admin/directMessage/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getDirectMessage(ruuid, uuid) {
  return await PrivateApiCall.get(`/admin/directMessage/${ruuid}/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function addDirectMessage(ruuid, data) {
  return await PrivateApiCall.post(`/admin/directMessage/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function editDirectMessage(ruuid, uuid, data) {
  return await PrivateApiCall.put(`/admin/directMessage/${ruuid}/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function deleteDirectMessage(ruuid, uuid) {
  return await PrivateApiCall.delete(`/admin/directMessage/${ruuid}/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getDirectMessagesWithCustomers(ruuid) {
  return await PrivateApiCall.get(`/admin/directMessage/all/customers/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}


/** ******************************************************************************************* */
/** ************************************  NOTIFICATIONS  *************************************** */
/** ******************************************************************************************* */

async function registerDevice(token) {
  return await PrivateApiCall.post(`/admin/notifications`, { token: token })
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getNotifications() {
  return await PrivateApiCall.get(`/admin/notifications`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function viewNotification(uuid) {
  return await PrivateApiCall.put(`/admin/notifications/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function confirmNotification(uuid) {
  return await PrivateApiCall.put(`/admin/notifications/delivered/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

/** ******************************************************************************************* */
/** ************************************ DASHBOARD  *************************************** */
/** ******************************************************************************************* */

const reshapeUrl = (baseUrl, ruuid, filterString, selectedCurrency) => {
  let final = baseUrl
  if (ruuid !== 'all-restaurants' && ruuid) {
    final += `/${ruuid}/`
  }
  if (filterString)
    final += filterString
  if (selectedCurrency)
    final += `&currency=${selectedCurrency}`
  return final
}

async function getTopSpenders(ruuid, filterString, selectedCurrency) {
  return await PrivateApiCall.get(reshapeUrl(`/admin/dashboard/top-customers`, ruuid, filterString, selectedCurrency))
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getAvgOrderPrice(ruuid, filterString, selectedCurrency) {
  return await PrivateApiCall.get(reshapeUrl('/admin/dashboard/avg-order-price', ruuid, filterString, selectedCurrency))
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getLateOrders(ruuid, filterString, selectedCurrency) {
  return await PrivateApiCall.get(reshapeUrl('/admin/dashboard/late-orders', ruuid, filterString, selectedCurrency))
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getTotalOrders(ruuid, filterString, selectedCurrency) {
  return await PrivateApiCall.get(reshapeUrl('/admin/dashboard/total-orders', ruuid, filterString, selectedCurrency))
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getNewCustomers(ruuid, filterString, selectedCurrency) {
  return await PrivateApiCall.get(reshapeUrl('/admin/dashboard/get-customer-count', ruuid, filterString, selectedCurrency))
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getCanceledOrders(ruuid, filterString, selectedCurrency) {
  return await PrivateApiCall.get(reshapeUrl('/admin/dashboard/canceled-orders', ruuid, filterString, selectedCurrency))
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getTotalCustomers() {
  return await PrivateApiCall.get('/admin/dashboard/total-customers')
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getSalesByZone(ruuid, filterString, selectedCurrency) {
  return await PrivateApiCall.get(reshapeUrl('/admin/dashboard/sales-by-zone', ruuid, filterString, selectedCurrency))
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getSalesByAffiliate() {
  return await PrivateApiCall.get(`/admin/dashboard/sales-by-affiliate`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getSignupsByAffiliate() {
  return await PrivateApiCall.get(`/admin/dashboard/sign-ups-by-affiliate`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}
//NEW APIS
async function getTotalDiscounts(ruuid, filterString, selectedCurrency) {
  return await PrivateApiCall.get(reshapeUrl(`/admin/dashboard/total-discounts`, ruuid, filterString, selectedCurrency))
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getTotalPromoDiscounts(ruuid, filterString, selectedCurrency) {
  return await PrivateApiCall.get(reshapeUrl(`/admin/dashboard/total-promo-discounts`, ruuid, filterString, selectedCurrency))
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getTopXItemsQty(ruuid, filterString, selectedCurrency) {
  return await PrivateApiCall.get(reshapeUrl(`/admin/dashboard/top-x-items`, ruuid, filterString, selectedCurrency))
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getTopXItemsAmt(ruuid, filterString, selectedCurrency) {
  return await PrivateApiCall.get(reshapeUrl(`/admin/dashboard/top-x-items-amount`, ruuid, filterString, selectedCurrency))
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getNotActiveCustomers(ruuid, filterString, selectedCurrency) {
  return await PrivateApiCall.get(reshapeUrl(`/admin/dashboard/not-active-customers`, ruuid, filterString, selectedCurrency))
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getFeedbacksAndComplaints(ruuid, filterString, selectedCurrency) {
  return await PrivateApiCall.get(reshapeUrl(`/admin/dashboard/get-feedbacks`, ruuid, filterString, selectedCurrency))
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getFeedbacksRating(ruuid, filterString, selectedCurrency) {
  return await PrivateApiCall.get(reshapeUrl(`/admin/dashboard/get-feebacks-rating`, ruuid, filterString, selectedCurrency))
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getTotalRevenuePerMonth(ruuid, filterString, selectedCurrency) {
  return await PrivateApiCall.get(reshapeUrl(`/admin/dashboard/get-revenue-month`, ruuid, filterString, selectedCurrency))
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getNewProduct(ruuid, filterString, selectedCurrency) {
  return await PrivateApiCall.get(reshapeUrl(`/admin/dashboard/get-new-product`, ruuid, filterString, selectedCurrency))
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getCustomerCountValue(ruuid, filterString, selectedCurrency) {
  return await PrivateApiCall.get(reshapeUrl(`/admin/dashboard/get-customer-count-above-value`, ruuid, filterString, selectedCurrency))
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getCustomerCountOrder(ruuid, filterString, selectedCurrency) {
  return await PrivateApiCall.get(reshapeUrl(`/admin/dashboard/get-customer-count-above-count`, ruuid, filterString, selectedCurrency))
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getQrCount(ruuid, filterString, selectedCurrency) {
  return await PrivateApiCall.get(reshapeUrl(`/admin/dashboard/get-qr-count`, ruuid, filterString, selectedCurrency))
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getNewProductsList(ruuid, filterString, selectedCurrency) {
  return await PrivateApiCall.get(reshapeUrl(`/admin/dashboard/get-new-product-list`, ruuid, filterString, selectedCurrency))
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getFeedbacksSummary(ruuid, filterString, selectedCurrency) {
  return await PrivateApiCall.get(reshapeUrl(`/admin/dashboard/get-feedback-summary`, ruuid, filterString, selectedCurrency))
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getBirthdayCount(ruuid, filterString, selectedCurrency) {
  return await PrivateApiCall.get(reshapeUrl(`/admin/dashboard/get-birthday-count`, ruuid, filterString, selectedCurrency))
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getDeliveryStatus(ruuid, filterString, selectedCurrency) {
  return await PrivateApiCall.get(reshapeUrl(`/admin/dashboard/get-delivery-status`, ruuid, filterString, selectedCurrency))
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getNotSoldItems(ruuid, filterString, selectedCurrency) {
  return await PrivateApiCall.get(reshapeUrl(`/admin/dashboard/not-sold-items`, ruuid, filterString, selectedCurrency))
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getSalesByRestaurant(filterString, selectedCurrency) {
  return await PrivateApiCall.get(reshapeUrl(`/admin/dashboard/get-sales-by-restaurant`, undefined, filterString, selectedCurrency))
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getSalesByBranch(filterString, selectedCurrency) {
  return await PrivateApiCall.get(`/admin/dashboard/get-sales-by-branch`, undefined, filterString, selectedCurrency)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getAffiliateClicks() {
  return await PrivateApiCall.get(`/admin/dashboard/scans-by-affiliate`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getOrdersStatus(ruuid, filterString, selectedCurrency) {
  return await PrivateApiCall.get(reshapeUrl(`/admin/dashboard/get-today-orders`, ruuid, filterString, selectedCurrency))
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getTopItemsBranch(ruuid, filterString, selectedCurrency) {
  return await PrivateApiCall.get(reshapeUrl(`/admin/dashboard/top-x-items-items-by-branch`, ruuid, filterString, selectedCurrency))
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getAvgOrders(ruuid, filterString, selectedCurrency) {
  return await PrivateApiCall.get(reshapeUrl(`/admin/dashboard/get-avg-orders`, ruuid, filterString, selectedCurrency))
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getSalesByCategory(ruuid, filterString, selectedCurrency) {
  return await PrivateApiCall.get(reshapeUrl(`/admin/dashboard/get-sales-by-category`, ruuid, filterString, selectedCurrency))
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getSalesByCustomer(ruuid, filterString, selectedCurrency) {
  return await PrivateApiCall.get(reshapeUrl(`/admin/dashboard/get-sales-by-customer`, ruuid, filterString, selectedCurrency))
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getAvgPrepTime(ruuid, filterString, selectedCurrency) {
  return await PrivateApiCall.get(reshapeUrl(`/admin/dashboard/get-avg-prep-time`, ruuid, filterString, selectedCurrency))
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getAvgDeliveryTime(ruuid, filterString, selectedCurrency) {
  return await PrivateApiCall.get(reshapeUrl(`/admin/dashboard/get-avg-delivery-time`, ruuid, filterString, selectedCurrency))
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getRestaurantsCurrency() {
  return await PrivateApiCall.get(`/admin/dashboard/get-restaurants-currency`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getConsolidatedCurrency() {
  return await PrivateApiCall.get(`/admin/dashboard/get-consolidated-currency`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function setConsolidatedCurrency(data) {
  return await PrivateApiCall.post(`/admin/dashboard/set-consolidated-currency/`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getCardsPositioning() {
  return await PrivateApiCall.get(`admin/dashboard/get-cards-position/`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function setCardsPositioning(data) {
  return await PrivateApiCall.put(`/admin/dashboard/set-cards-position/`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** ************************************ EMAIL SETUP  *************************************** */
/** ******************************************************************************************* */

async function getEmailServer() {
  return await PrivateApiCall.get('/admin/email-server')
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function addEmailServer(data) {
  return await PrivateApiCall.post('/admin/email-server', data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function testEmail(data) {
  return await PrivateApiCall.post(`/admin/email-server/test`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ************************************************************************************** */
/** ************************************ PAYMENTS  *************************************** */
/** ************************************************************************************** */

async function addDefaultPayment(ruuid) {
  return await PrivateApiCall.post(`admin/payment/${ruuid}/auto-generate`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getPayments() {
  return await PrivateApiCall.get(`/admin/payment`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getPayment(uuid) {
  return await PrivateApiCall.get(`/admin/payment/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function editPayment(uuid, data) {
  return await PrivateApiCall.put(`/admin/payment/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function deletePayment(uuid) {
  return await PrivateApiCall.delete(`/admin/payment/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function addPayment(data) {
  return await PrivateApiCall.post(`/admin/payment`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ************************************************************************************** */
/** ********************************** CURRENCIES  *************************************** */
/** ************************************************************************************** */

async function getRates(ruuid) {
  return await PrivateApiCall.get(`admin/currency-rate/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getRate(ruuid, uuid) {
  return await PrivateApiCall.get(`admin/currency-rate/${ruuid}/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function editRate(ruuid, uuid, data) {
  return await PrivateApiCall.put(`/admin/currency-rate/${ruuid}/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function deleteRate(ruuid, uuid) {
  return await PrivateApiCall.delete(`/admin/currency-rate/${ruuid}/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function addRate(ruuid, data) {
  return await PrivateApiCall.post(`/admin/currency-rate/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function generateRates(ruuid) {
  return await PrivateApiCall.post(`admin/currency-rate/${ruuid}/auto-generate`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

//stock functions
/** ******************************************************************************************* */
/** ************************************** Recipes  ******************************************* */
/** ******************************************************************************************* */

async function getRecipeEquipment(ruuid, uuid) {
  return await PrivateApiCall.get(`admin/recipe/equipment/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function addRecipeEquipment(ruuid, data) {
  return await PrivateApiCall.post(`admin/recipe/equipment/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function editRecipeEquipment(ruuid, uuid, data) {
  return await PrivateApiCall.put(`admin/recipe/equipment/${ruuid}/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function startCooking(ruuid, uuid, data) {
  return await PrivateApiCall.put(`admin/recipe/product/${ruuid}/${uuid}/step-checked`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function addEditRecipeInstructions(ruuid, uuid, data) {
  return await PrivateApiCall.post(`admin/recipe/product/${ruuid}/${uuid}/instructions`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function deleteRecipeInstructions(ruuid, uuid) {
  return await PrivateApiCall.delete(`admin/recipe/product/${ruuid}/${uuid}/instructions`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getRecipeInstructions(ruuid, uuid) {
  const url = uuid
    ? `admin/recipe/product/${ruuid}/${uuid}/instructions`
    : `admin/recipe/products/${ruuid}/instructions`
  return await PrivateApiCall.get(url)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getCostAnalysisProduct(ruuid, puuid) {
  return await PrivateApiCall.get(`admin/recipe/product/${ruuid}/${puuid}/cost-analysis`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getRecipesProducts(ruuid, page, limit, groups, search, hasRecipes) {
  // Build query parameters, excluding undefined values
  const params = new URLSearchParams();
  if (page !== undefined && page !== null) params.append('page', page);
  if (limit !== undefined && limit !== null) params.append('limit', limit);
  if (groups !== undefined && groups !== null) params.append('productGroupUuids', groups);
  if (search !== undefined && search !== null) params.append('search', search);
  if (hasRecipes !== undefined && hasRecipes !== null) params.append('hasRecipes', hasRecipes);

  const queryString = params.toString();
  const url = `admin/recipe/products/${ruuid}${queryString ? `?${queryString}` : ''}`;

  return await PrivateApiCall.get(url)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getRecipeData(ruuid, puuid, smdUuid) {
  // Build query parameters, excluding undefined values
  const params = new URLSearchParams();
  if (puuid !== undefined && puuid !== null) params.append('productUuid', puuid);
  if (smdUuid !== undefined && smdUuid !== null) params.append('smdItemUuid', smdUuid);

  const queryString = params.toString();
  const url = `admin/recipe/${ruuid}/data${queryString ? `?${queryString}` : ''}`;

  return await PrivateApiCall.get(url)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getAllRecipes(ruuid, category, page, limit, sortBy, sortOrder) {
  // Build query parameters, excluding undefined values
  const params = new URLSearchParams();
  if (category !== undefined && category !== null) params.append('category', category);
  if (page !== undefined && page !== null) params.append('page', page);
  if (limit !== undefined && limit !== null) params.append('limit', limit);
  if (sortBy !== undefined && sortBy !== null) params.append('sortBy', sortBy);
  if (sortOrder !== undefined && sortOrder !== null) params.append('sortOrder', sortOrder);

  const queryString = params.toString();
  const url = `admin/recipe/${ruuid}${queryString ? `?${queryString}` : ''}`;

  return await PrivateApiCall.get(url)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getRecipeByCategory(ruuid, categoryName) {
  return await PrivateApiCall.get(`admin/recipe/category/${ruuid}/${categoryName}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getSingleRecipe(ruuid, uuid) {
  return await PrivateApiCall.get(`admin/recipe/${ruuid}/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getSingleProductRecipes(ruuid, puuid) {
  return await PrivateApiCall.get(`admin/recipe/product/${ruuid}/${puuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function addRecipe(ruuid, data) {
  return await PrivateApiCall.post(`admin/recipe/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function bulkCreateRecipes(ruuid, data) {
  return await PrivateApiCall.post(`admin/recipe/${ruuid}/bulk-create`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function updateRecipe(ruuid, uuid, data) {
  return await PrivateApiCall.put(`admin/recipe/${ruuid}/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function deleteRecipe(ruuid, uuid) {
  return await PrivateApiCall.delete(`admin/recipe/${ruuid}/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getCostAnalysis(ruuid, uuid, modules) {
  // Build query parameters, handling modules array properly
  const params = new URLSearchParams();
  if (modules && Array.isArray(modules) && modules.length > 0) {
    // Add each module as a separate parameter or join them appropriately
    // Depending on API expectation, could be: modules=mod1&modules=mod2 or modules=mod1,mod2
    modules.forEach(module => {
      if (module !== undefined && module !== null && module !== '') {
        params.append('modules', module);
      }
    });
  }

  const queryString = params.toString();
  const url = `admin/recipe/${ruuid}/${uuid}/cost-analysis${queryString ? `?${queryString}` : ''}`;

  return await PrivateApiCall.get(url)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function applyMarkup(ruuid, uuid, data) {
  return await PrivateApiCall.post(`admin/recipe/${ruuid}/${uuid}/apply-markup`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/**
 * Save or update product cost configurations (bulk operation)
 * POST /api/admin/recipe/product/:ruuid/:productUuid/cost-config
 * 
 * @param {string} ruuid - Restaurant UUID (required)
 * @param {string} productUuid - Product UUID (required)
 * @param {Array<Object>} configs - Array of configuration objects (minimum 1 item required)
 *   Each config object should have:
 *   - markup: {number|null} - Markup percentage (optional, can be null, min: 0)
 *   - targetCost: {number} - Target cost (required, min: 0)
 *   - module: {string} - Must be one of: 'dine-in', 'delivery', or 'pickup' (required)
 *   - size: {string|null|undefined} - Size name for products with sizes (optional, omit or set to null/empty string for products without sizes)
 * @returns {Promise<Response>} Promise with saved configurations and any errors
 * 
 * @example
 * saveProductCostConfig(ruuid, productUuid, [
 *   { markup: 250, targetCost: 10.5, module: "dine-in" },
 *   { markup: 250, targetCost: 12.0, module: "dine-in", size: "Large" },
 *   { markup: null, targetCost: 12.0, module: "delivery" }
 * ])
 */
async function saveProductCostConfig(ruuid, productUuid, configs) {
  return await PrivateApiCall.post(`admin/recipe/product/${ruuid}/${productUuid}/cost-config`, configs)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function updateRecipeInstructions(ruuid, uuid, data) {
  return await PrivateApiCall.put(`admin/recipe/${ruuid}/${uuid}/instructions`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function searchRecipes(ruuid, query, category, modules, page, limit) {
  // Build query parameters, excluding undefined values
  const params = new URLSearchParams();
  if (query !== undefined && query !== null) params.append('query', query);
  if (category !== undefined && category !== null) params.append('category', category);
  if (modules !== undefined && modules !== null) params.append('modules', modules);
  if (page !== undefined && page !== null) params.append('page', page);
  if (limit !== undefined && limit !== null) params.append('limit', limit);

  const queryString = params.toString();
  const url = `admin/recipe/${ruuid}/search${queryString ? `?${queryString}` : ''}`;

  return await PrivateApiCall.get(url)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getRecipeAnalysis(ruuid, category, modules, dateFrom, dateTo, page, limit) {
  // Build query parameters, excluding undefined values
  const params = new URLSearchParams();
  if (category !== undefined && category !== null) params.append('category', category);
  if (modules !== undefined && modules !== null) params.append('modules', modules);
  if (dateFrom !== undefined && dateFrom !== null) params.append('dateFrom', dateFrom);
  if (dateTo !== undefined && dateTo !== null) params.append('dateTo', dateTo);
  if (page !== undefined && page !== null) params.append('page', page);
  if (limit !== undefined && limit !== null) params.append('limit', limit);

  const queryString = params.toString();
  const url = `admin/recipe/analysis/${ruuid}${queryString ? `?${queryString}` : ''}`;

  return await PrivateApiCall.get(url)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getRecipeItems() {
  return await PrivateApiCall.get(`admin/recipe/items`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getCardsStatistics(ruuid) {
  return await PrivateApiCall.get(`admin/recipe/counts/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getRecipeExportTemplate(ruuid) {
  return await PrivateApiCall.get(`admin/recipe/export/template/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function importRecipes(ruuid, formData) {
  return await PrivateApiCall.post(`admin/recipe/import/${ruuid}`, formData)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** ************************************** UOM  ******************************************* */
/** ******************************************************************************************* */
async function getUoms() {
  return await PrivateApiCall.get(`admin/smdUom`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getConnectedUoms(itemUuid) {
  return await PrivateApiCall.get(`/admin/SmdUOM/${itemUuid}/connected`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getUom(uuid) {
  return await PrivateApiCall.get(`admin/smdUom/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function addUom(data) {
  return await PrivateApiCall.post(`admin/smdUom`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function editUom(uuid, data) {
  return await PrivateApiCall.put(`admin/smdUom/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function deleteUom(uuid) {
  return await PrivateApiCall.delete(`admin/smdUom/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function bulkUpdateUoms(data) {
  return await PrivateApiCall.put(`admin/smdUOM`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** ***************************************** PUOM  ******************************************* */
/** ******************************************************************************************* */
async function getPuoms() {
  return await PrivateApiCall.get(`/admin/SmdPUOM`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getPuom(uuid) {
  return await PrivateApiCall.get(`/admin/SmdPUOM/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function addPuom(data) {
  return await PrivateApiCall.post(`/admin/SmdPUOM`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function editPuom(uuid, data) {
  return await PrivateApiCall.put(`/admin/SmdPUOM/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function deletePuom(uuid) {
  return await PrivateApiCall.delete(`/admin/SmdPUOM/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** *********************************** UOM Conversions  ************************************** */
/** ******************************************************************************************* */
async function getConversions() {
  return await PrivateApiCall.get(`admin/smdUomConversion`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getConversion(uuid) {
  return await PrivateApiCall.get(`admin/smdUomConversion/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function addConversion(data) {
  return await PrivateApiCall.post(`admin/smdUomConversion`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function editConversion(uuid, data) {
  return await PrivateApiCall.put(`admin/smdUomConversion/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function deleteConversion(uuid) {
  return await PrivateApiCall.delete(`admin/smdUomConversion/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function bulkUpdateConversions(data) {
  return await PrivateApiCall.put(`admin/smdUOMConversion`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** *********************************** Stock Items  ****************************************** */
/** ******************************************************************************************* */

async function getStockItems() {
  return await PrivateApiCall.get(`admin/SmdItem/all`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getStockItem(uuid) {
  return await PrivateApiCall.get(`admin/SmdItem/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/**
 * Is a barcode still free? Barcodes identify a row across the *whole* catalog — stock items and
 * purchased products alike — because every operation screen resolves a scan against both. The forms
 * ask as each barcode is added rather than on save, so the person finds out while they still know
 * which barcode they just scanned.
 *
 * @param {object} params
 * @param {string|string[]} params.barcode One barcode, or several to check in a single round trip.
 * @param {string} [params.itemUuid] Stock item being edited — its own barcodes read as free.
 * @param {string} [params.linkedItemUuid] Purchased product being edited — same.
 * @returns {Promise<object>} `{ data: { available, results: [{ barcode, available, conflict }] } }`
 */
async function checkBarcodeAvailability({ barcode, itemUuid, linkedItemUuid } = {}) {
  const q = new URLSearchParams()
  const values = Array.isArray(barcode) ? barcode : [barcode]
  values.filter((v) => v != null && String(v).trim()).forEach((v) => q.append('barcodes', String(v).trim()))
  if (itemUuid) q.append('itemUuid', itemUuid)
  if (linkedItemUuid) q.append('linkedItemUuid', linkedItemUuid)
  return await PrivateApiCall.get(`admin/SmdItem/barcodes/check?${q.toString()}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/**
 * Open Food Facts product-name search, asked through our API (search.openfoodfacts.org sends no
 * CORS headers). Resolves `{ products, count }`, or null when the API can't answer.
 */
async function searchOpenFoodFactsProducts({ q, langs = [] } = {}) {
  const query = new URLSearchParams({ q })
  if (langs.length) query.append('langs', langs.join(','))
  const res = await PrivateApiCall.get(`admin/open-food-facts/search?${query.toString()}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
  return res?.status === 200 && Array.isArray(res?.data?.products) ? res.data : null
}

async function addStockItem(data) {
  return await PrivateApiCall.post(`admin/SmdItem`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function editStockItem(uuid, data) {
  return await PrivateApiCall.put(`admin/SmdItem/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function bulkUpdateStockItems(data) {
  return await PrivateApiCall.put(`admin/SmdItem/bulk-edit`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function updateStockItemImages(data) {
  return await PrivateApiCall.put(`/admin/SmdItem/images`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function bulkAddStockItems(data) {
  return await PrivateApiCall.post(`admin/SmdItem/bulk-add`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getStockItemsExportTemplate() {
  return await PrivateApiCall.get(`admin/SmdItem/export/template`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function importStockItems(formData) {
  return await PrivateApiCall.post(`/admin/SmdItem/import`, formData)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getSmdItemSupplierPricing(uuid) {
  return await PrivateApiCall.get(`admin/SmdItem/${uuid}/supplier-pricing`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** *********************************** Production Setup ************************************** */
/** ******************************************************************************************* */

async function getSmdItemProductionSetup(uuid) {
  return await PrivateApiCall.get(`admin/SmdItem/${uuid}/production-setup`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function upsertSmdItemProductionSetup(uuid, data) {
  return await PrivateApiCall.put(`admin/SmdItem/${uuid}/production-setup`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** *********************************** Stock Location  *************************************** */
/** ******************************************************************************************* */

async function getStockLocations(buuid) {
  return await PrivateApiCall.get(`admin/SmdLocation${(buuid && buuid!=='0') ? `?buuid=${buuid}` : ''}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function addStockLocation(data) {
  return await PrivateApiCall.post(`admin/SmdLocation`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function editStockLocation(uuid, data) {
  return await PrivateApiCall.put(`admin/SmdLocation/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function deleteStockLocation(uuid) {
  return await PrivateApiCall.delete(`admin/SmdLocation/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/**
 * GET /admin/stock/:ruuid/stock-movements
 * Query: smdItemUuid (required by API), branchUuid?, locationUuid?, smdLinkedItemUuid?, source?, fromDate?, toDate?, limit?, offset?
 */
async function getStockMovements(ruuid, params = {}) {
  if (!ruuid) {
    return Promise.reject(new Error('Restaurant uuid is required'))
  }
  const q = new URLSearchParams()
  const {
    smdItemUuid,
    branchUuid,
    locationUuid,
    smdLinkedItemUuid,
    source,
    fromDate,
    toDate,
    limit,
    offset,
  } = params
  if (smdItemUuid) q.append('smdItemUuid', smdItemUuid)
  if (branchUuid) q.append('branchUuid', branchUuid)
  if (locationUuid) q.append('locationUuid', locationUuid)
  if (smdLinkedItemUuid) q.append('smdLinkedItemUuid', smdLinkedItemUuid)
  if (source) q.append('source', source)
  if (fromDate) q.append('fromDate', fromDate)
  if (toDate) q.append('toDate', toDate)
  if (limit != null && limit !== '') q.append('limit', String(limit))
  if (offset != null && offset !== '') q.append('offset', String(offset))
  const qs = q.toString()
  return await PrivateApiCall.get(`admin/stock/${encodeURIComponent(ruuid)}/stock-movements${qs ? `?${qs}` : ''}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/**
 * GET /admin/stock/:ruuid/item-location-qtys
 * Query: branchUuid?, locationUuid?, smdItemUuid?, smdLinkedItemUuid?
 */
async function getItemLocationQtys(params = {}) {
  const q = new URLSearchParams()
  const { restaurantUuid, branchUuid, locationUuid, smdItemUuid, smdLinkedItemUuid } = params
  if (restaurantUuid) q.append('restaurantUuid', restaurantUuid)
  if (branchUuid) q.append('branchUuid', branchUuid)
  if (locationUuid) q.append('locationUuid', locationUuid)
  if (smdItemUuid) q.append('smdItemUuid', smdItemUuid)
  if (smdLinkedItemUuid) q.append('smdLinkedItemUuid', smdLinkedItemUuid)
  const qs = q.toString()
  return await PrivateApiCall.get(`admin/stock/item-location-qtys${qs ? `?${qs}` : ''}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** *********************************** Reorder Points  *************************************** */
/** ******************************************************************************************* */

async function getSmdItemRecipes(uuid) {
  return await PrivateApiCall.get(`/admin/SmdItem/${uuid}/recipes`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function updateSmdItemRecipeQuantities(uuid, data) {
  return await PrivateApiCall.put(`/admin/SmdItem/${uuid}/recipes/quantities`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function getItemReorderLevels(uuid) {
  return await PrivateApiCall.get(`admin/SmdItemReorder/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getMissingItemReorderLevels(uuid) {
  return await PrivateApiCall.get(`admin/SmdItemReorder/missing/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getAllMissingItemReorderLevels() {
  return await PrivateApiCall.get(`admin/SmdItemReorder/missing/all`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function addEditReorderLevel(data) {
  return await PrivateApiCall.post(`admin/SmdItemReorder`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function bulkAddEditReorderLevels(data) {
  return await PrivateApiCall.post(`admin/SmdItemReorder/bulk`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function deleteReorderLevel(uuid) {
  return await PrivateApiCall.delete(`admin/SmdItemReorder/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** *********************************** Linked Items(Purchased Products)  ********************* */
/** ******************************************************************************************* */

async function getLinkedItems() {
  return await PrivateApiCall.get(`admin/SmdLinkedItem/all`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getLinkedItem(uuid) {
  return await PrivateApiCall.get(`admin/SmdLinkedItem/all/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function addLinkedItem(data) {
  return await PrivateApiCall.post(`admin/SmdLinkedItem`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function editLinkedItem(uuid, data) {
  return await PrivateApiCall.put(`admin/SmdLinkedItem/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function deleteLinkedItem(uuid) {
  return await PrivateApiCall.delete(`admin/SmdLinkedItem/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/**
 * Stars a purchased product with one of its suppliers (the favourite pair) — or, for a product with no
 * supplier (`suuid` empty), the product itself (RESTOAPP-7542).
 */
async function setFavoriteLinkedItem(liuuid, suuid) {
  const url = suuid
    ? `admin/SmdLinkedItem/${liuuid}/supplier/${suuid}/favorite`
    : `admin/SmdLinkedItem/${liuuid}/favorite`
  return await PrivateApiCall.post(url)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function bulkUpdateLinkedItems(data) {
  return await PrivateApiCall.put(`admin/SmdLinkedItem/bulk-edit`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function bulkAddLinkedItems(data) {
  return await PrivateApiCall.post(`admin/SmdLinkedItem/bulk-add`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getLinkedItemsExportTemplate() {
  return await PrivateApiCall.get(`admin/SmdLinkedItem/export/template`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function importLinkedItems(formData) {
  return await PrivateApiCall.post(`/admin/SmdLinkedItem/import`, formData)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** *********************************** Stock Categories  ************************************* */
/** ******************************************************************************************* */
async function getStockCategories() {
  return await PrivateApiCall.get(`admin/smdItemCategory`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getStockCategory(uuid) {
  return await PrivateApiCall.get(`admin/smdItemCategory/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function addStockCategory(data) {
  return await PrivateApiCall.post(`admin/smdItemCategory`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function editStockCategory(uuid, data) {
  return await PrivateApiCall.put(`admin/smdItemCategory/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function deleteStockCategory(uuid) {
  return await PrivateApiCall.delete(`admin/smdItemCategory/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function bulkUpdateStockCategories(data) {
  return await PrivateApiCall.put(`admin/smdItemCategory`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function updateStockCategoryImages(data) {
  return await PrivateApiCall.put(`/admin/smdItemCategory/images`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** ************************************ Stock Groups  **************************************** */
/** ******************************************************************************************* */
async function getStockGroups() {
  return await PrivateApiCall.get(`admin/smdItemGroup`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getStockGroup(uuid) {
  return await PrivateApiCall.get(`admin/smdItemGroup/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function addStockGroup(data) {
  return await PrivateApiCall.post(`admin/smdItemGroup`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function editStockGroup(uuid, data) {
  return await PrivateApiCall.put(`admin/smdItemGroup/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function deleteStockGroup(uuid) {
  return await PrivateApiCall.delete(`admin/smdItemGroup/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function bulkUpdateStockGroups(data) {
  return await PrivateApiCall.put(`admin/smdItemGroup`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function updateStockGroupImages(data) {
  return await PrivateApiCall.put(`/admin/smdItemGroup/images`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** *********************************** Stock Lists  ****************************************** */
/** ******************************************************************************************* */
async function getStockLists() {
  return await PrivateApiCall.get('admin/stock-lists')
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function createStockList(data) {
  return await PrivateApiCall.post('admin/stock-lists', data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function updateStockList(uuid, data) {
  return await PrivateApiCall.put(`admin/stock-lists/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function updateStockListContent(uuid, data) {
  return await PrivateApiCall.put(`admin/stock-lists/${uuid}/content`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function deleteStockList(uuid) {
  return await PrivateApiCall.delete(`admin/stock-lists/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** Sort stock lists: PUT /admin/stock-lists/sort - payload: { lists: [{ uuid, order }, ...] } */
async function sortStockLists(data) {
  return await PrivateApiCall.put('admin/stock-lists/sort', data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** Stock List Assignments: GET all (optional query: operationType, restaurantUuid, branchUuid) */
async function getStockListAssignments(params = {}) {
  const q = new URLSearchParams();
  if (params.operationType) q.set('operationType', params.operationType);
  if (params.restaurantUuid) q.set('restaurantUuid', params.restaurantUuid);
  if (params.branchUuid) q.set('branchUuid', params.branchUuid);
  const query = q.toString();
  const url = `admin/stock-lists/assignments${query ? `?${query}` : ''}`;
  return await PrivateApiCall.get(url)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** Stock List Assignments: GET one */
async function getStockListAssignment(operationType, restaurantUuid, branchUuid) {
  return await PrivateApiCall.get(
    `admin/stock-lists/assignments/${operationType}/${restaurantUuid}/${branchUuid}`
  )
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** Stock List Assignments: PUT (upsert) */
async function putStockListAssignment(operationType, restaurantUuid, branchUuid, data) {
  return await PrivateApiCall.put(
    `admin/stock-lists/assignments/${operationType}/${restaurantUuid}/${branchUuid}`,
    data
  )
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** Stock List Assignments: PATCH (partial update) */
async function patchStockListAssignment(operationType, restaurantUuid, branchUuid, data) {
  return await PrivateApiCall.patch(
    `admin/stock-lists/assignments/${operationType}/${restaurantUuid}/${branchUuid}`,
    data
  )
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** Stock List Assignments: POST bulk copy */
async function postStockListAssignmentsBulk(data) {
  return await PrivateApiCall.post('admin/stock-lists/assignments/bulk', data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** Stock List Assignments: DELETE one */
async function deleteStockListAssignment(operationType, restaurantUuid, branchUuid) {
  return await PrivateApiCall.delete(
    `admin/stock-lists/assignments/${operationType}/${restaurantUuid}/${branchUuid}`
  )
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** *********************************** Virtual Locations  *********************************** */
/** ******************************************************************************************* */
// Virtual locations are org-global: list / add / edit take no restaurant. The remaining routes
// still sit behind the restaurant validator (ruuid) — see VirtualLocationActions for which one.
async function getVirtualLocations() {
  return await PrivateApiCall.get(`admin/virtual-locations/`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function addVirtualLocation(data) {
  return await PrivateApiCall.post(`admin/virtual-locations/`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function addVirtualLocationWithLocations(ruuid, data) {
  return await PrivateApiCall.post(`admin/virtual-locations/with-locations/${ruuid}/`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function editVirtualLocation(uuid, data) {
  return await PrivateApiCall.put(`admin/virtual-locations/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function bulkSetVirtualLocationToSmdLocation(ruuid, data) {
  return await PrivateApiCall.post(`admin/virtual-locations/smd-locations/bulk/${ruuid}/`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

// Table Zone APIs
async function bulkSetTableZoneAssignments(ruuid, data) {
  return await PrivateApiCall.post(`admin/virtual-locations/table-zones/assignments/bulk/${ruuid}/`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function getTableZones(ruuid, buuid) {
  return await PrivateApiCall.get(`admin/virtual-locations/table-zones/${ruuid}/?branchUuid=${buuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function addTableZone(ruuid, data) {
  return await PrivateApiCall.post(`admin/virtual-locations/table-zones/${ruuid}/`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function bulkAddTableZones(ruuid, data) {
  return await PrivateApiCall.post(`admin/virtual-locations/table-zones/bulk/${ruuid}/`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function bulkEditTableZones(ruuid, data) {
  return await PrivateApiCall.put(`admin/virtual-locations/table-zones/bulk/${ruuid}/`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function bulkSetTableZones(ruuid, data) {
  return await PrivateApiCall.post(`admin/virtual-locations/table-zones/bulk/${ruuid}/`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function deleteTableZone(ruuid, uuid) {
  return await PrivateApiCall.delete(`admin/virtual-locations/table-zones/${ruuid}/${uuid}/`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

// Floor Assignment APIs
async function getFloorAssignments(ruuid, buuid) {
  return await PrivateApiCall.get(`admin/virtual-locations/floor-assignments/${ruuid}/?branchUuid=${buuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function bulkSetFloorAssignments(ruuid, data) {
  return await PrivateApiCall.post(`admin/virtual-locations/floor-assignments/bulk/${ruuid}/`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function deleteVirtualLocation(ruuid, uuid) {
  return await PrivateApiCall.delete(`admin/virtual-locations/${ruuid}/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

// POS products belong to a restaurant, so the list is always one restaurant's products.
async function getVirtualLocationProducts(ruuid, { signal } = {}) {
  return await PrivateApiCall.get(`admin/virtual-locations/products/${ruuid}/`, { signal })
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getProductRoutingPreview(ruuid, buuid, options = {}) {
  const { page, limit, search, productGroupUuids } = options
  const params = new URLSearchParams()
  // When "all branches" is selected (buuid '0' or empty) do not send branchUuid
  if (buuid && buuid !== '0') params.append('branchUuid', buuid)
  if (page) params.append('page', page)
  if (limit) params.append('limit', limit)
  if (search) params.append('search', search)
  if (Array.isArray(productGroupUuids)) productGroupUuids.forEach((uuid) => params.append('productGroup', uuid))
  const query = params.toString()
  return await PrivateApiCall.get(`admin/virtual-locations/product-routing-preview/${ruuid}/${query ? `?${query}` : ''}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getVirtualLocationsConfig(ruuid, buuid) {
  return await PrivateApiCall.get(`admin/virtual-locations/config/${ruuid}/?branchUuid=${buuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function setVirtualLocationsConfig(ruuid, buuid, data) {
  return await PrivateApiCall.post(`admin/virtual-locations/config/${ruuid}/?branchUuid=${buuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

// Additive: points `productUuids` (min 1, all of restaurant `ruuid`) at the VL; it never unassigns.
async function assignProductsToVirtualLocation(ruuid, data) {
  return await PrivateApiCall.put(`admin/virtual-locations/products/bulk/${ruuid}/`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

// Stock items / groups assignment — mirrors the POS product assignment endpoint above
// (products/bulk -> stock-items/bulk, productUuids -> stockItemUuids).
async function assignStockItemsToVirtualLocation(ruuid, data) {
  return await PrivateApiCall.put(`admin/virtual-locations/stock-items/bulk/${ruuid}/`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

// POS Routing APIs
async function getWorkstations(ruuid, buuid) {
  if (!buuid || buuid === '0' || buuid === 'all') {
    return;
  }
  return await PrivateApiCall.get(`admin/workstation/${ruuid}/${buuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getPosAssignments(ruuid, buuid) {
  const branchParam = buuid && buuid !== '0' ? `?branchUuid=${buuid}` : '';
  return await PrivateApiCall.get(`admin/virtual-locations/pos-assignments/${ruuid}/${branchParam}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function bulkSetPosAssignments(ruuid, data) {
  return await PrivateApiCall.post(`admin/virtual-locations/pos-assignments/bulk/${ruuid}/`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** ****************************** B2B Virtual Location Routing  ****************************** */
/** ******************************************************************************************* */

async function getB2bVlAssignments(ruuid, buuid) {
  const branchParam = buuid && buuid !== '0' ? `?branchUuid=${buuid}` : '';
  return await PrivateApiCall.get(`admin/b2b-virtual-location/${ruuid}/${branchParam}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function bulkAssignB2bVlAssignments(ruuid, data) {
  return await PrivateApiCall.put(`admin/b2b-virtual-location/${ruuid}/bulk-assign`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function deleteB2bVlAssignment(ruuid, uuid) {
  return await PrivateApiCall.delete(`admin/b2b-virtual-location/${ruuid}/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** ******************************** B2B Sales Settings  ************************************** */
/** ******************************************************************************************* */

/**
 * Branch-level B2B sales settings (GeneralConfiguration module `b2bSales`).
 * Response: `{ b2bSalesSettings: { optionalExpiryDate: boolean } }` — defaults to
 * `optionalExpiryDate: true` when no row exists yet.
 */
async function getB2bSalesSettings(ruuid, buuid) {
  return await PrivateApiCall.get(`admin/general-config/b2b-sales-settings/${ruuid}/${buuid}/`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** `data` = `{ values: { optionalExpiryDate: boolean } }` (Joi requires the boolean). */
async function setB2bSalesSettings(ruuid, buuid, data) {
  return await PrivateApiCall.put(`admin/general-config/b2b-sales-settings/${ruuid}/${buuid}/`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** *********************************** Stock Types  ************************************* */
/** ******************************************************************************************* */

async function getStockTypes() {
  return await PrivateApiCall.get(`admin/smdItemType`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** *********************************** Stock Wastage  ************************************* */
/** ******************************************************************************************* */

async function getStockWastages() {
  return await PrivateApiCall.get(`admin/stock-wastage`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getStockWastage(uuid) {
  return await PrivateApiCall.get(`admin/stock-wastage/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function addStockWastage(data) {
  return await PrivateApiCall.post(`admin/stock-wastage`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function editStockWastage(uuid, data) {
  return await PrivateApiCall.put(`admin/stock-wastage/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function deleteStockWastage(uuid) {
  return await PrivateApiCall.delete(`admin/stock-wastage/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getWastageSettings() {
  return await PrivateApiCall.get(`admin/stock-wastage/settings`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function saveWastageSettings(data) {
  return await PrivateApiCall.put(`admin/stock-wastage/settings`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** *********************************** Stock Brand  ************************************* */
/** ******************************************************************************************* */

async function getStockBrands() {
  return await PrivateApiCall.get(`admin/stock-brand`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getStockBrand(uuid) {
  return await PrivateApiCall.get(`admin/stock-brand/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function addStockBrand(data) {
  return await PrivateApiCall.post(`admin/stock-brand`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function editStockBrand(uuid, data) {
  return await PrivateApiCall.put(`admin/stock-brand/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function deleteStockBrand(uuid) {
  return await PrivateApiCall.delete(`admin/stock-brand/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** ************************************ Stock Suppliers ************************************** */
/** ******************************************************************************************* */
async function getStockSuppliers() {
  return await PrivateApiCall.get(`admin/smdSupplier`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getStockSupplier(uuid) {
  return await PrivateApiCall.get(`admin/smdSupplier/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function addStockSupplier(data) {
  return await PrivateApiCall.post(`admin/smdSupplier`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function editStockSupplier(uuid, data) {
  return await PrivateApiCall.put(`admin/smdSupplier/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function deleteStockSupplier(uuid) {
  return await PrivateApiCall.delete(`admin/smdSupplier/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function bulkUpdateStockSuppliers(data) {
  return await PrivateApiCall.put(`admin/smdSupplier`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function updateStockSupplierImages(data) {
  return await PrivateApiCall.put(`/admin/smdSupplier/images`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/**
 * Accounts-payable "payments due" reads (see docs/admin-supplier-ap-api.md in main-backend).
 * An item is one *installment* of a purchase invoice's payment schedule, identified by
 * `purchaseInvoiceUuid` + `installmentIndex` — not the invoice itself.
 */
function supplierPaymentsDueParams(opts) {
  const params = {}
  if (opts?.status) params.status = opts.status
  if (opts?.q) params.q = opts.q
  if (opts?.supplierUuid) params.supplierUuid = opts.supplierUuid
  if (opts?.branchUuid) params.branchUuid = opts.branchUuid
  if (opts?.asOf) params.asOf = opts.asOf
  if (opts?.includeFuture === false) params.includeFuture = 'false'
  if (opts?.includePaid) params.includePaid = 'true'
  return Object.keys(params).length > 0 ? { params } : undefined
}

/** Hub: every supplier's open installments + KPI buckets + per-supplier bundles. */
async function getAllSupplierPaymentsDue(opts) {
  return await PrivateApiCall.get(`admin/smdSupplier/payments-due`, supplierPaymentsDueParams(opts))
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** One supplier's installments, plus `tabs` counts for Due & Overdue / Upcoming / All unpaid. */
async function getSupplierPaymentsDue(uuid, opts) {
  return await PrivateApiCall.get(`admin/smdSupplier/${uuid}/payments-due`, supplierPaymentsDueParams(opts))
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/**
 * Statement of account: supplier header, the whole AP ledger (purchases, credit notes, payments)
 * and the running totals. Takes no filters — the endpoint always returns the full ledger, so any
 * date/search narrowing happens client-side.
 */
async function getSupplierApStatement(uuid) {
  return await PrivateApiCall.get(`admin/smdSupplier/${uuid}/ap-statement`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/**
 * Record a payment against a supplier's account.
 *
 * The body is validated by a plain Joi object, so an unknown key answers 422: it is exactly
 * `{ amount, paymentUuid, notes?, branchUuid?, allocations? }`. `allocations` targets specific
 * installments (`purchaseInvoiceUuid` + `installmentIndex`); omitting it lets the backend settle
 * the balance oldest-invoice-first.
 */
async function postSupplierApPayment(uuid, data) {
  return await PrivateApiCall.post(`admin/smdSupplier/${uuid}/ap-payments`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** ************************************ Stripe Connect ************************************** */
/** ******************************************************************************************* */

async function createStripeSession(ruuid, buuid) {
  return await PrivateApiCall.post(`/admin/stripe/${ruuid}/${buuid}/create-session`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function createStripeAccount(ruuid, buuid) {
  return await PrivateApiCall.post(`/admin/stripe/${ruuid}/${buuid}/account`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function getStripeAccount(ruuid, buuid) {
  return await PrivateApiCall.get(`/admin/stripe/${ruuid}/${buuid}/account`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

/** ******************************************************************************************* */
/** ************************************** Delivery Sources *********************************** */
/** ******************************************************************************************* */

async function getDeliverySources(ruuid) {
  return await PrivateApiCall.get(`/admin/deliverySource/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function getDeliverySource(ruuid, uuid) {
  return await PrivateApiCall.get(`/admin/deliverySource/${ruuid}/${uuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function addDeliverySource(ruuid, data) {
  return await PrivateApiCall.post(`/admin/deliverySource/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error));
}

async function editDeliverySource(ruuid, uuid, data) {
  return await PrivateApiCall.put(`/admin/deliverySource/${ruuid}/${uuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function deleteDeliverySource(ruuid, data) {
  return await PrivateApiCall.delete(`/admin/deliverySource/${ruuid}/${data}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function updateSourcesImages(ruuid, data) {
  return await PrivateApiCall.put(`/admin/deliverySource/images/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** ************************************** Activity Logs *********************************** */
/** ******************************************************************************************* */

async function getActivityLogs(query) {
  return await PrivateApiCall.get(`/admin/activities/${query ? query : ''}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getPages() {
  return await PrivateApiCall.get(`/admin/activities/pages`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** *********************************** PO Invoice Print Settings ***************************** */
/** ******************************************************************************************* */

async function getPoInvoicePrintSettings(ruuid) {
  return await PrivateApiCall.get(`admin/po-invoice-print-settings/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function savePoInvoicePrintSettings(ruuid, data) {
  return await PrivateApiCall.post(`admin/po-invoice-print-settings/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** ********************************* Purchase Order Print Settings *************************** */
/** ******************************************************************************************* */

async function getPurchaseOrderPrintSettings(ruuid) {
  return await PrivateApiCall.get(`admin/purchase-order-print-settings/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function savePurchaseOrderPrintSettings(ruuid, data) {
  return await PrivateApiCall.post(`admin/purchase-order-print-settings/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** *********************************** Transfer Print Settings ******************************* */
/** ******************************************************************************************* */

async function getTransferPrintSettings(ruuid) {
  return await PrivateApiCall.get(`admin/transfer-print-settings/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function saveTransferPrintSettings(ruuid, data) {
  return await PrivateApiCall.post(`admin/transfer-print-settings/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** *********************************** Wastage Print Settings ******************************** */
/** ******************************************************************************************* */

async function getWastagePrintSettings(ruuid) {
  return await PrivateApiCall.get(`admin/wastage-print-settings/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function saveWastagePrintSettings(ruuid, data) {
  return await PrivateApiCall.post(`admin/wastage-print-settings/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** ********************************* Production Print Settings ******************************* */
/** ******************************************************************************************* */

// One design per view of the SMA production cart: 'summary' | 'details' | 'ingredients'. The query
// is inlined in the URL (not axios params) — the queued ADM client drops `params`.
async function getProductionPrintSettings(ruuid, view = 'details') {
  return await PrivateApiCall.get(`admin/production-print-settings/${ruuid}?view=${encodeURIComponent(view)}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function saveProductionPrintSettings(ruuid, data, view = 'details') {
  return await PrivateApiCall.post(`admin/production-print-settings/${ruuid}?view=${encodeURIComponent(view)}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** ************************************ Label Print Settings ********************************* */
/** ******************************************************************************************* */

/** Item-label (sticker) template used by SMA productions → Print Labels. */
async function getLabelPrintSettings(ruuid) {
  return await PrivateApiCall.get(`admin/label-print-settings/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function saveLabelPrintSettings(ruuid, data) {
  return await PrivateApiCall.post(`admin/label-print-settings/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** Named label templates — every label print screen picks one; exactly one is the default. */
async function getLabelPrintPresets(ruuid) {
  return await PrivateApiCall.get(`admin/label-print-settings/presets/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** Saved label print lists ("print later") of one catalogue page: stockItem | purchasedProduct | product. */
async function getLabelPrintLists(ruuid, source) {
  return await PrivateApiCall.get(`admin/label-print-settings/lists/${ruuid}?source=${encodeURIComponent(source || "")}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function createLabelPrintList(ruuid, data) {
  return await PrivateApiCall.post(`admin/label-print-settings/lists/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function updateLabelPrintList(ruuid, listUuid, data) {
  return await PrivateApiCall.put(`admin/label-print-settings/lists/${ruuid}/${listUuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function deleteLabelPrintList(ruuid, listUuid) {
  return await PrivateApiCall.delete(`admin/label-print-settings/lists/${ruuid}/${listUuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function createLabelPrintPreset(ruuid, data) {
  return await PrivateApiCall.post(`admin/label-print-settings/presets/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function updateLabelPrintPreset(ruuid, presetUuid, data) {
  return await PrivateApiCall.put(`admin/label-print-settings/presets/${ruuid}/${presetUuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function deleteLabelPrintPreset(ruuid, presetUuid) {
  return await PrivateApiCall.delete(`admin/label-print-settings/presets/${ruuid}/${presetUuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** Product-label templates (menu products → Print Labels) — named presets, one is the default. */
async function getProductLabelPrintPresets(ruuid) {
  return await PrivateApiCall.get(`admin/product-label-print-settings/presets/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function createProductLabelPrintPreset(ruuid, data) {
  return await PrivateApiCall.post(`admin/product-label-print-settings/presets/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function updateProductLabelPrintPreset(ruuid, presetUuid, data) {
  return await PrivateApiCall.put(`admin/product-label-print-settings/presets/${ruuid}/${presetUuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function deleteProductLabelPrintPreset(ruuid, presetUuid) {
  return await PrivateApiCall.delete(`admin/product-label-print-settings/presets/${ruuid}/${presetUuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** Saved product-label print lists — always the Products page's (`source` is pinned server-side). */
async function getProductLabelPrintLists(ruuid) {
  return await PrivateApiCall.get(`admin/product-label-print-settings/lists/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function createProductLabelPrintList(ruuid, data) {
  return await PrivateApiCall.post(`admin/product-label-print-settings/lists/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function updateProductLabelPrintList(ruuid, listUuid, data) {
  return await PrivateApiCall.put(`admin/product-label-print-settings/lists/${ruuid}/${listUuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function deleteProductLabelPrintList(ruuid, listUuid) {
  return await PrivateApiCall.delete(`admin/product-label-print-settings/lists/${ruuid}/${listUuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** ********************************* Stock Count Print Settings ****************************** */
/** ******************************************************************************************* */

async function getStockCountPrintSettings(ruuid) {
  return await PrivateApiCall.get(`admin/stock-count-print-settings/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function saveStockCountPrintSettings(ruuid, data) {
  return await PrivateApiCall.post(`admin/stock-count-print-settings/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** ******************************* B2B Quotation Print Settings ****************************** */
/** ******************************************************************************************* */

async function getQuotationPrintSettings(ruuid) {
  return await PrivateApiCall.get(`admin/quotation-print-settings/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function saveQuotationPrintSettings(ruuid, data) {
  return await PrivateApiCall.post(`admin/quotation-print-settings/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** ********************************* B2B Sales Print Settings ******************************** */
/** ******************************************************************************************* */

async function getSalesPrintSettings(ruuid) {
  return await PrivateApiCall.get(`admin/sales-print-settings/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function saveSalesPrintSettings(ruuid, data) {
  return await PrivateApiCall.post(`admin/sales-print-settings/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** ***************************** B2B Kitchen Order Print Settings **************************** */
/** ******************************************************************************************* */

async function getKitchenOrderPrintSettings(ruuid) {
  return await PrivateApiCall.get(`admin/kitchen-order-print-settings/${ruuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function saveKitchenOrderPrintSettings(ruuid, data) {
  return await PrivateApiCall.post(`admin/kitchen-order-print-settings/${ruuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** ****************************** Customer Statement Print Settings ************************** */
/** ******************************************************************************************* */

/**
 * One template for the whole tenant (no restaurant).
 * `design`: 'a4' (default) or 'thermal' (80mm roll) — each design is saved separately.
 */
async function getCustomerStatementPrintSettings(design = 'a4') {
  return await PrivateApiCall.get(`admin/customer-statement-print-settings?design=${design}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function saveCustomerStatementPrintSettings(data, design = 'a4') {
  return await PrivateApiCall.post(`admin/customer-statement-print-settings?design=${design}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** ****************************** Customer Receipt Print Settings **************************** */
/** ******************************************************************************************* */

/** `design`: 'a4' (default) or 'thermal' (80mm roll) — each design is saved separately. */
async function getCustomerReceiptPrintSettings(ruuid, design = 'a4') {
  return await PrivateApiCall.get(`admin/customer-receipt-print-settings/${ruuid}?design=${design}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function saveCustomerReceiptPrintSettings(ruuid, data, design = 'a4') {
  return await PrivateApiCall.post(`admin/customer-receipt-print-settings/${ruuid}?design=${design}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** ****************************** Supplier Statement Print Settings ************************** */
/** ******************************************************************************************* */

/** One template for the whole tenant (no restaurant). */
async function getSupplierStatementPrintSettings() {
  return await PrivateApiCall.get(`admin/supplier-statement-print-settings`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function saveSupplierStatementPrintSettings(data) {
  return await PrivateApiCall.post(`admin/supplier-statement-print-settings`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

/** ******************************************************************************************* */
/** ************************************ B2B PRICE LEVELS ************************************* */
/** ******************************************************************************************* */

async function getB2bPriceLevels(ruuid) {
  return await PrivateApiCall.get(`/admin/b2b-price-level/${ruuid}/`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getB2bPriceLevel(ruuid, puuid) {
  return await PrivateApiCall.get(`/admin/b2b-price-level/${ruuid}/${puuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function createB2bPriceLevel(ruuid, data) {
  return await PrivateApiCall.post(`/admin/b2b-price-level/${ruuid}/`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function updateB2bPriceLevel(ruuid, puuid, data) {
  return await PrivateApiCall.put(`/admin/b2b-price-level/${ruuid}/${puuid}`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function deleteB2bPriceLevel(ruuid, puuid) {
  return await PrivateApiCall.delete(`/admin/b2b-price-level/${ruuid}/${puuid}`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getB2bPriceLevelProducts(ruuid, priceLevelUuid = null) {
  const url = priceLevelUuid
    ? `/admin/b2b-price-level/${ruuid}/products/base-prices?priceLevelUuid=${priceLevelUuid}`
    : `/admin/b2b-price-level/${ruuid}/products/base-prices`
  return await PrivateApiCall.get(url)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getB2bPriceLevelProductGroups(ruuid) {
  return await PrivateApiCall.get(`/admin/b2b-price-level/${ruuid}/product-groups`)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function bulkUpdateB2bBasePrices(ruuid, data) {
  return await PrivateApiCall.put(`/admin/b2b-price-level/${ruuid}/bulk-update-base-prices`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function updateB2bBasePricesByCriteria(ruuid, data) {
  return await PrivateApiCall.put(`/admin/b2b-price-level/${ruuid}/update-base-prices-by-criteria`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function updateB2bPriceLevelPricesByCriteria(ruuid, data) {
  return await PrivateApiCall.put(`/admin/b2b-price-level/${ruuid}/update-price-level-prices-by-criteria`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function bulkUpdateB2bPriceLevelPrices(ruuid, data) {
  return await PrivateApiCall.put(`/admin/b2b-price-level/${ruuid}/bulk-update-prices`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function getB2bPriceLevelSmdItems(ruuid, priceLevelUuid = null) {
  const url = priceLevelUuid
    ? `/admin/b2b-price-level/${ruuid}/smd-items/base-prices?priceLevelUuid=${priceLevelUuid}`
    : `/admin/b2b-price-level/${ruuid}/smd-items/base-prices`
  return await PrivateApiCall.get(url)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function bulkUpdateB2bSmdItemPrices(ruuid, data) {
  return await PrivateApiCall.put(`/admin/b2b-price-level/${ruuid}/bulk-update-smd-item-prices`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

async function bulkUpdateB2bSmdLinkedItemPrices(ruuid, data) {
  return await PrivateApiCall.put(`/admin/b2b-price-level/${ruuid}/bulk-update-smd-linked-item-prices`, data)
    .then((response) => response)
    .catch((error) => errorCatch(error))
}

export {
  //B2B PRICE LEVELS
  getB2bPriceLevels,
  getB2bPriceLevel,
  createB2bPriceLevel,
  updateB2bPriceLevel,
  deleteB2bPriceLevel,
  getB2bPriceLevelProducts,
  getB2bPriceLevelProductGroups,
  bulkUpdateB2bBasePrices,
  updateB2bBasePricesByCriteria,
  updateB2bPriceLevelPricesByCriteria,
  bulkUpdateB2bPriceLevelPrices,
  getB2bPriceLevelSmdItems,
  bulkUpdateB2bSmdItemPrices,
  bulkUpdateB2bSmdLinkedItemPrices,
  //DIRECT MESSAGES
  getDirectMessagesWithCustomers,
  deleteDirectMessage,
  editDirectMessage,
  addDirectMessage,
  getDirectMessage,
  getDirectMessages,
  //EMAIL-SETUP
  getEmailServer,
  addEmailServer,
  testEmail,
  //CURRENCIES
  getRates,
  getRate,
  addRate,
  editRate,
  deleteRate,
  generateRates,
  //PAYMENTS
  addDefaultPayment,
  getPayments,
  getPayment,
  editPayment,
  deletePayment,
  addPayment,
  //DASHBOARD
  getTopSpenders,
  getAvgOrderPrice,
  getLateOrders,
  getTotalOrders,
  getNewCustomers,
  getCanceledOrders,
  getSalesByZone,
  getTotalCustomers,
  getSalesByAffiliate,
  getSignupsByAffiliate,
  getTotalDiscounts,
  getTotalPromoDiscounts,
  getTopXItemsQty,
  getTopXItemsAmt,
  getNotActiveCustomers,
  getFeedbacksAndComplaints,
  getFeedbacksRating,
  getTotalRevenuePerMonth,
  getNewProduct,
  getCustomerCountValue,
  getCustomerCountOrder,
  getQrCount,
  getNewProductsList,
  getFeedbacksSummary,
  getBirthdayCount,
  getDeliveryStatus,
  getNotSoldItems,
  getSalesByRestaurant,
  getSalesByBranch,
  getAffiliateClicks,
  getOrdersStatus,
  getTopItemsBranch,
  getAvgOrders,
  getSalesByCategory,
  getSalesByCustomer,
  getAvgDeliveryTime,
  getAvgPrepTime,
  getRestaurantsCurrency,
  setConsolidatedCurrency,
  getConsolidatedCurrency,
  setCardsPositioning,
  getCardsPositioning,
  // NOTIFICATIONS
  registerDevice,
  getNotifications,
  viewNotification,
  confirmNotification,
  //AUTOMATED-MESSAGES
  getAutomatedMessages,
  getAutomatedMessage,
  addAutomatedMessage,
  editAutomatedMessage,
  deleteAutomatedMessage,
  //PRODUCTS-AVAILABILITY
  getProductsAvailability,
  deleteProductAvailability,
  updateProductsAvailability,
  //QR
  addQR,
  addQrTables,
  addQrButton,
  editQrButton,
  deleteQrButton,
  deleteQrTable,
  getQrButton,
  getQrButtons,
  getQr,
  validateURL,
  getQrTables,
  getTableOrderingSettings,
  addEditTableOrderingSettings,
  getQrOnlineDelivery,
  addOnlineDeliveryQr,
  getQROrderingSettings,
  setQROrderingSettings,
  //ENTITY QR
  //qr
  getEntityQr,
  addEditEntityQr,
  //qr tables
  getEntityQrTables,
  addEntityQrTables,
  deleteEntityQrTable,
  //qr buttons
  getEntityQrButtons,
  getEntityQrButton,
  addEntityQrButton,
  editEntityQrButton,
  deleteEntityQrButton,
  // AUTH
  login,
  forgotPass,
  otp,
  verifyOTP,
  // ME INFO
  getMeProfile,
  editMeProfile,
  // Admin PROFILES
  getAdminProfiles,
  addAdminProfile,
  editAdminProfile,
  deleteAdminProfile,
  // RESTAURANT
  getRestaurants,
  addRestaurant,
  editRestaurant,
  deleteRestaurant,
  // BRANCHES
  getBranches,
  getAllBranches,
  addBranch,
  editBranch,
  deleteBranch,
  getBranchesTableOrdering,
  getBranchesLoyalty,
  getBranchesQRMenu,
  getBranchesOnlineDelivery,
  getBranchesOrders,
  // ENTITIES
  getEntities,
  addEntity,
  editEntity,
  bulkUpdateEntities,
  deleteEntity,
  // GLOBAL CONFIG
  getGlobalConfig,
  uploadImage,
  bulkUploadImages,
  uploadQr,
  // CATEGORY
  getCategories,
  addCategory,
  editCategory,
  deleteCategory,
  bulkUpdateCategories,
  importCategories,
  updateCategoryImages,
  bulkAddCategories,
  // GROUPS
  getGroups,
  addGroup,
  editGroup,
  deleteGroup,
  updateGroups,
  bulkEditGroups,
  bulkAddGroups,
  exportGroupsExcel,
  importGroupsExcel,
  // PRODUCTS
  getProducts,
  getProduct,
  addProduct,
  updateProducts,
  editProduct,
  deleteProduct,
  deleteProductImage,
  editProductImage,
  editBulkProducts,
  addBulkProducts,
  getRewardsProducts,
  getAddEditProducts,
  generateImage,
  uploadProductMediaGallery,
  importProducts,
  getProductExelTemplate,
  // TAXES
  getTaxes,
  addTax,
  editTax,
  deleteTax,
  getBranchTaxes,
  updateBranchTaxes,
  applyTaxesToProducts,
  getProductsWithTaxes,
  applyTaxesToAllProducts,
  getModifiersWithTaxes,
  applyTaxesToModifiers,
  // Ingredients
  getIngredients,
  addIngredient,
  editIngredient,
  deleteIngredient,
  bulkUpdateIngredients,
  updateIngredientImages,
  bulkAddIngredients,
  exportIngredientsExcel,
  importIngredientsExcel,
  // TYPES AND ALLERGIES
  getTypesAndAllergies,
  getSingleTypeAndAllergies,
  addTypesAndAllergies,
  editTypesAndAllergies,
  deleteTypesAndAllergies,
  updateTypesAndAllergies,
  bulkUpdateTypes,
  bulkAddTypes,
  exportFoodTypesExcel,
  importFoodTypesExcel,
  // MODIFIERS
  getModifiers,
  getModifier,
  addModifier,
  editModifier,
  deleteModifier,
  updateModifiers,
  bulkUpdateModifiers,
  bulkAddModifiers,
  exportModifiersExcel,
  importModifiersExcel,
  // MODIFIERSGROUPS
  getModifiersGroups,
  getModifierGroup,
  getModifierGroupWithModifiers,
  getModifiersGroupsWithModifiers,
  addModifierGroup,
  editModifierGroup,
  deleteModifierGroup,
  bulkUpdateModifierGroups,
  bulkAddModifierGroups,
  exportModGroupsExcel,
  importModGroupsExcel,
  // MENU
  getMenu,
  getMenus,
  addMenu,
  editMenu,
  deleteMenu,
  editMenuName,
  updateMenuSorting,
  // TRANSLATIONS
  getTranslations,
  getTranslationPages,
  editTranslations,
  aiTranslate,
  aiGenerateDescription,
  getSupportedLanguagesSettings,
  editSupportedLanguagesSettings,
  getSupportedLanguages,
  getMissingTranslations,
  //Roles
  getRoles,
  addRole,
  editRole,
  deleteRole,
  //Users
  getUsers,
  addUser,
  editUser,
  deleteUser,
  editUserSettings,
  changeAccountActivity,
  changeAccountVerification,
  getAppUsers,
  getAppUser,
  addAppUser,
  editAppUser,
  bulkEditAppUsers,
  bulkAddAppUsers,
  deleteAppUser,
  getRestaurantsWithBranches,
  exportAppUsersExcel,
  importAppUsersExcel,
  //APP USERS ADDRESSES
  getAppUserAddresses,
  addAppUserAddress,
  editAppUserAddress,
  deleteAppUserAddress,
  //APP USERS GROUPS
  getAppUsersGroups,
  addAppUsersGroup,
  editAppUsersGroup,
  deleteAppUsersGroup,
  //ALLERGENS
  getAllergens,
  getAllergen,
  addAllergen,
  editAllergen,
  deleteAllergen,
  bulkUpdateAllergens,
  bulkAddAllergens,
  updateAllergensImages,
  //DELIVERY-ZONE
  getDeliveryZones,
  getDeliveryZone,
  addDeliveryZone,
  editDeliveryZone,
  deleteDeliveryZone,
  getOnlineDeliverySettings,
  getAllOnlineDeliverySettings,
  addEditDeliverySettings,
  //EVENTS
  getEvents,
  getEvent,
  addEvent,
  editEvent,
  deleteEvent,
  //MEDIA
  getAllMediaInteractions,
  getAllMedia,
  addMedia,
  editMedia,
  deleteMedia,
  hideMedia,
  showMedia,
  sortMedia,
  updateMedia,
  //GALLERY
  getGallery,
  uploadGallery,
  updateLayout,
  deleteGallery,
  getGalleryCategories,
  getGalleryCategory,
  addGalleryCategory,
  editGalleryCategory,
  deleteGalleryCategory,
  //FEEDBACK
  getFeedbackTemplate,
  editFeedbackTemplate,
  editFeedbackTemplateMessage,
  getFeedback,
  addFeedback,
  editFeedbackComplaint,
  //MODULES
  getModules,
  //PLATFORMS
  getPlatforms,
  addPlatform,
  editPlatform,
  deletePlatform,
  //PROMOTIONS
  getAllPromotions,
  getPromotion,
  addPromotion,
  editPromotion,
  deletePromotion,
  //BRANCHES-FINANCE
  getBranchesFinance,
  updateBranchesFinancePrice,
  updateBranchesFinanceAvailability,
  getBranchesFinanceProduct,
  //LOYALTY
  getLoyalty,
  addEditLoyalty,
  addEditLoyaltyDescription,
  getLoyaltyDescription,
  getLoyaltyUsers,
  addLoyaltyConfig,
  getLoyaltyConfig,
  getLoyaltyMenu,
  addEditLoyaltyMenu,
  getCashback,
  getGifts,
  getGift,
  addEditCashback,
  editGift,
  addGift,
  deleteGift,
  getRewardsBasedOnLevel,
  getRewardBasedOnLevel,
  addRewardBasedOnLevel,
  editRewardBasedOnLevel,
  deleteRewardBasedOnLevel,
  editLoyaltyPoints,
  getLoyaltyUserEntries,
  //DISCOUNT
  getAllDiscount,
  getDiscount,
  addDiscount,
  editDiscount,
  deleteDiscount,
  sortDiscount,
  editDiscountSettings,
  getDiscountSettings,
  //ORDERS
  getOrders,
  checkIfOrderMeetsFilters,
  getOrder,
  cancelOrder,
  acceptOrder,
  rejectOrder,
  completeOrder,
  dispatchOrder,
  updateDispatchSettings,
  getDrivers,
  getDriver,
  undispatchOrder,
  undispatchAllOrders,
  setBusy,
  setBusyAll,
  closeDay,
  getUnclosedDays,
  setClosed,
  setClosedAll,
  //REPORTS
  getTodayReport,
  getClosedReport,
  getReportDates,
  //REASONS
  getReasons,
  addReason,
  editReason,
  deleteReason,
  //ORDERS HISTORY
  getOrdersHistory,
  //DESIGN SETUP
  getDesignSetupGlobalSettings,
  editDesignSetupGlobalSettings,
  getDesignSetup,
  editDesignSetup,
  //LOGIN DESIGN SETUP
  getLoginDesignSetup,
  editLoginDesignSetup,
  //SPLASH SCREEN DESIGN SETUP
  getSplashScreenDesignSetup,
  editSplashScreenDesignSetup,
  //RESTAURANTS DESIGN SETUP
  getRestaurantsDesignSetup,
  editRestaurantsDesignSetup,
  //FLOOR SETUP
  getFloors,
  getFloor,
  getTables,
  editOrAddFloorsAndTables,
  deleteTheFloor,
  deleteTable,
  getBranchesFloorSetup,
  //URL LINK
  getAffiliateLink,
  addAffiliateLink,
  editAffiliateLink, deleteAffiliateLink,
  //STOCK
  //RECIPES
  getCostAnalysisProduct,
  getRecipesProducts,
  getRecipeData,
  getAllRecipes,
  getRecipeByCategory,
  getSingleRecipe,
  getSingleProductRecipes,
  addRecipe,
  bulkCreateRecipes,
  updateRecipe,
  deleteRecipe,
  getCostAnalysis,
  applyMarkup,
  saveProductCostConfig,
  getRecipeInstructions,
  deleteRecipeInstructions,
  startCooking,
  getRecipeEquipment,
  addRecipeEquipment,
  editRecipeEquipment,
  addEditRecipeInstructions,
  updateRecipeInstructions,
  searchRecipes,
  getRecipeAnalysis,
  getRecipeItems,
  getCardsStatistics,
  getRecipeExportTemplate,
  importRecipes,
  //UOM
  getUoms,
  getConnectedUoms,
  getUom,
  addUom,
  editUom,
  deleteUom,
  bulkUpdateUoms,
  //PUOMS
  getPuoms,
  getPuom,
  addPuom,
  editPuom,
  deletePuom,
  //UOM CONVERSIONS
  getConversions,
  getConversion,
  addConversion,
  editConversion,
  deleteConversion,
  bulkUpdateConversions,
  //STOCK ITEMS
  getStockItems,
  getStockItem,
  checkBarcodeAvailability,
  searchOpenFoodFactsProducts,
  addStockItem,
  editStockItem,
  bulkUpdateStockItems,
  updateStockItemImages,
  bulkAddStockItems,
  getStockItemsExportTemplate,
  importStockItems,
  getSmdItemSupplierPricing,
  // Production Setup
  getSmdItemProductionSetup,
  upsertSmdItemProductionSetup,
  //Stock Location
  getStockLocations,
  addStockLocation,
  editStockLocation,
  deleteStockLocation,
  getStockMovements,
  getItemLocationQtys,
  //Reorder Point
  getSmdItemRecipes,
  updateSmdItemRecipeQuantities,
  getItemReorderLevels,
  addEditReorderLevel,
  bulkAddEditReorderLevels,
  deleteReorderLevel,
  getMissingItemReorderLevels,
  getAllMissingItemReorderLevels,
  //LINKED ITEMS
  getLinkedItems,
  getLinkedItem,
  addLinkedItem,
  editLinkedItem,
  deleteLinkedItem,
  setFavoriteLinkedItem,
  bulkUpdateLinkedItems,
  bulkAddLinkedItems,
  getLinkedItemsExportTemplate,
  importLinkedItems,
  //STOCK CATEGORIES
  getStockCategories,
  getStockCategory,
  addStockCategory,
  editStockCategory,
  deleteStockCategory,
  bulkUpdateStockCategories,
  updateStockCategoryImages,
  //STOCK GROUPS
  getStockGroups,
  getStockGroup,
  addStockGroup,
  editStockGroup,
  deleteStockGroup,
  bulkUpdateStockGroups,
  updateStockGroupImages,
  //STOCK LISTS
  getStockLists,
  createStockList,
  updateStockList,
  updateStockListContent,
  deleteStockList,
  sortStockLists,
  //STOCK LIST ASSIGNMENTS
  getStockListAssignments,
  getStockListAssignment,
  putStockListAssignment,
  patchStockListAssignment,
  postStockListAssignmentsBulk,
  deleteStockListAssignment,
  //VIRTUAL LOCATIONS
  getVirtualLocations,
  addVirtualLocation,
  addVirtualLocationWithLocations,
  editVirtualLocation,
  bulkSetVirtualLocationToSmdLocation,
  deleteVirtualLocation,
  getVirtualLocationsConfig,
  setVirtualLocationsConfig,
  getVirtualLocationProducts,
  getProductRoutingPreview,
  assignProductsToVirtualLocation,
  assignStockItemsToVirtualLocation,
  getTableZones,
  addTableZone,
  bulkSetTableZones,
  bulkAddTableZones,
  bulkEditTableZones,
  deleteTableZone,
  bulkSetTableZoneAssignments,
  //FLOOR ROUTING
  getFloorAssignments,
  bulkSetFloorAssignments,
  //POS ROUTING
  getWorkstations,
  getPosAssignments,
  bulkSetPosAssignments,
  //B2B VIRTUAL LOCATION ROUTING
  getB2bVlAssignments,
  bulkAssignB2bVlAssignments,
  deleteB2bVlAssignment,
  //B2B SALES SETTINGS
  getB2bSalesSettings,
  setB2bSalesSettings,
  //STOCK SUPPLIERS
  getStockSuppliers,
  getStockSupplier,
  addStockSupplier,
  editStockSupplier,
  deleteStockSupplier,
  bulkUpdateStockSuppliers,
  updateStockSupplierImages,
  getAllSupplierPaymentsDue,
  getSupplierPaymentsDue,
  getSupplierApStatement,
  postSupplierApPayment,
  //Stock Types
  getStockTypes,
  //Stock Wastage
  getStockWastages,
  getStockWastage,
  addStockWastage,
  editStockWastage,
  deleteStockWastage,
  getWastageSettings,
  saveWastageSettings,
  // Stock Brand
  getStockBrands,
  getStockBrand,
  addStockBrand,
  editStockBrand,
  deleteStockBrand,
  // Stripe Connect
  createStripeSession,
  createStripeAccount,
  getStripeAccount,
  // Delivery Sources
  getDeliverySource,
  getDeliverySources,
  addDeliverySource,
  editDeliverySource,
  deleteDeliverySource,
  updateSourcesImages,
  //Pos Users
  getPosUsers,
  getPosUser,
  getPosBranches,
  getAllPosBranches,
  addPosUser,
  editPosUser,
  deletePosUser,
  //Activity Logs
  getActivityLogs,
  getPages,
  // PO Invoice Print Settings
  getPoInvoicePrintSettings,
  savePoInvoicePrintSettings,
  // Purchase Order Print Settings
  getPurchaseOrderPrintSettings,
  savePurchaseOrderPrintSettings,
  // Transfer Print Settings
  getTransferPrintSettings,
  saveTransferPrintSettings,
  // Wastage Print Settings
  getWastagePrintSettings,
  saveWastagePrintSettings,
  getProductionPrintSettings,
  saveProductionPrintSettings,
  getLabelPrintSettings,
  saveLabelPrintSettings,
  getLabelPrintPresets,
  getLabelPrintLists,
  createLabelPrintList,
  updateLabelPrintList,
  deleteLabelPrintList,
  createLabelPrintPreset,
  updateLabelPrintPreset,
  deleteLabelPrintPreset,
  getProductLabelPrintPresets,
  createProductLabelPrintPreset,
  updateProductLabelPrintPreset,
  deleteProductLabelPrintPreset,
  getProductLabelPrintLists,
  createProductLabelPrintList,
  updateProductLabelPrintList,
  deleteProductLabelPrintList,
  // Stock Count Print Settings
  getStockCountPrintSettings,
  saveStockCountPrintSettings,
  // B2B Quotation / Sales Print Settings
  getQuotationPrintSettings,
  saveQuotationPrintSettings,
  getSalesPrintSettings,
  saveSalesPrintSettings,
  getKitchenOrderPrintSettings,
  saveKitchenOrderPrintSettings,

  getCustomerStatementPrintSettings,
  saveCustomerStatementPrintSettings,

  getCustomerReceiptPrintSettings,
  saveCustomerReceiptPrintSettings,

  getSupplierStatementPrintSettings,
  saveSupplierStatementPrintSettings,
};
